<template>
  <div class="survey-page" ref="surveyPage" id="surveyPage">
    <el-progress
      class="progressBar"
      :percentage="toEndPerc || percentage"
      :show-text="false"
    ></el-progress>
    <p
      class="survey-countdown-notice"
      ref="countdownNotice"
      v-if="showCountDownNotice"
    >
      {{ countdownTime }}
    </p>
    <div class="preview-topbar" v-if="SOURCE == 'wapPreview'">
      <span>预览状态下添加数据不被记录</span>
      <a v-if="isSkinPreview" href="javascript:;" @click="handleUseSkin">
        使用该皮肤
      </a>
    </div>
    <div
      class="survey-status"
      v-if="survey.status == 2 && SOURCE != 'wapPreview'"
    >
      <div class="status-icon">!</div>
      问卷已暂停回收，提交将不记录数据
    </div>
    <div
      v-if="!recyleStartStatus"
      class="survey-content"
      :class="{
        'survey-preview': SOURCE == 'pcPreview',
        active: survey.pages.length > 0 && activePage == survey.pages.length && isShowCtrl('hideCopyRightOrAD'),
        'is-bottom': isBottom
      }"
    >
      <div
        class="survey-wrap"
        :class="{
          'survey-preview': SOURCE == 'pcPreview',
          active: survey.pages.length > 0 && activePage == survey.pages.length
        }"
      >
        <div v-if="!survey.ipLimited && isCorrect" class="survey-main">
          <template v-if="activePage == 0">
            <div class="head-img" v-show="isShowCtrl('addHeadPig')">
              <img :src="headImg" />
            </div>
            <h1 class="survey-title" v-if="isShowCtrl('hideTitle')">
              <div class="survey-inner" v-html="survey.title"></div>
            </h1>
            <div class="survey-prefix" v-if="isShowCtrl('hidePrefix')">
              <div class="survey-inner" v-html="survey.prefix"></div>
            </div>
          </template>
          <div
            class="survey-pages"
            :class="{
              active: activePage == pageIndex,
              noQNum: !isShowCtrl('hideQuestionNumber')
            }"
            v-for="(item, pageIndex) in survey.pages"
            :key="pageIndex"
          >
            <template v-for="(ques, index) in item.questions">
              <div
                v-if="controlArr[ques.index] || ques.type === 'description'"
                :ref="'ques_' + ques.realIndex"
                :key="index"
                :class="'ques-item-' + ques.type"
              >
                <el-form
                  :model="ques"
                  label-width="80px"
                  class="question-viewer"
                  @submit.native.prevent
                >
                  <div>
                    <div
                      v-if="
                        winWidth <= divideVal &&
                          ques.type == 'matrixRadio' &&
                          ques.options.length > 3
                      "
                    >
                      <div
                        class="ques-title"
                        v-if="ques.type !== 'description'"
                      >
                        <span class="ques-title-idx">{{
                          survey.settings.titleIndex
                            ? getOrder(ques.index) + '.'
                            : ''
                        }}</span>
                        <p
                          v-if="ques.type !== 'textMultiple'"
                          class="ques-title-inner"
                          v-html="
                            (ques.inputTitle || ques.title) +
                              '(该题目选项可向左滑动)'
                          "
                        ></p>
                        <text-multiple
                          v-else
                          :ques="ques"
                          @finish="handleTextMulFinish(ques)"
                          @unfinish="handleTextMulUnFinish(ques)"
                        ></text-multiple>
                        <i v-if="ques.required" class="required-icon">*</i>
                      </div>
                    </div>
                    <div v-else>
                      <div
                        class="ques-title"
                        v-if="ques.type !== 'description'"
                      >
                        <span class="ques-title-idx">{{
                          survey.settings.titleIndex
                            ? getOrder(ques.index) + '.'
                            : ''
                        }}</span>
                        <p
                          v-if="ques.type !== 'textMultiple'"
                          class="ques-title-inner"
                          v-html="ques.inputTitle || ques.title"
                        ></p>
                        <text-multiple
                          v-else
                          :ques="ques"
                          @finish="handleTextMulFinish(ques)"
                          @unfinish="handleTextMulUnFinish(ques)"
                        ></text-multiple>
                        <i v-if="ques.required" class="required-icon">*</i>
                      </div>
                    </div>
                    <p
                      v-if="
                        unFinishedArr.indexOf(ques.realIndex) > -1 &&
                          !ques.isFinish &&
                          ques.type !== 'description'
                      "
                      class="unFinishedTips"
                    >
                      这道题也需要作答哦~
                    </p>
                    <p class="ques-desc">{{ ques.description }}</p>
                    <div
                      :class="genOptionClass(ques)"
                      v-if="ques.type === 'radio'"
                    >
                      <div v-if="!ques.referFlag">
                        <el-radio-group
                          @change="handleCheckRadio(ques, ques.index)"
                          v-model="ques.checkedLabel"
                        >
                          <el-radio
                            :class="'row-' + ques.maxRow"
                            :key="idx"
                            :style="bfColor(ques)"
                            :label="option.text"
                            :name="'radio-' + pageIndex + '-' + index"
                            v-for="(option, idx) in ques.options"
                          >
                            <span
                              class="otherStr"
                              @click="handleShowDialog(ques)"
                              readonly="readonly"
                              v-if="
                                option.text == ques.checkedLabel &&
                                  option.id === '98'
                              "
                              >{{ ques.blankSetting[0].value }}</span
                            >
                            <p
                              :class="{
                                radioContent: true,
                                radioContentVote: ques.showVote
                              }"
                              v-html="option.text"
                            >
                              {{ option.text }}
                            </p>
                            <div v-if="ques.showVote" class="pull-right">
                              <span class="voteCountDisp"
                                >{{
                                  (ques.voteCountMap[
                                    'voteCount' + SURVEY_ID + option.id
                                  ] || 0) + Number(option.checked)
                                }}票</span
                              >
                              <span class="votePercDisp"
                                >{{
                                  (
                                    (((ques.voteCountMap[
                                      'voteCount' + SURVEY_ID + option.id
                                    ] || 0) +
                                      Number(option.checked)) /
                                      (ques.countSum || 1)) *
                                    100
                                  ).toFixed(2)
                                }}%</span
                              >
                            </div>
                          </el-radio>
                        </el-radio-group>
                      </div>
                      <div v-else>
                        <span v-if="!ques.isAnswer"
                          >此题选项来源于{{
                            ques.referIndex
                          }}题中的选项，请先填写第{{ ques.referIndex }}题</span
                        >
                        <el-radio-group
                          v-else
                          @change="handleCheckRadio(ques, ques.index)"
                          v-model="ques.checkedLabel"
                        >
                          <template v-for="(option, idx) in ques.options">
                            <el-radio
                              v-if="option.display"
                              :class="'row-' + ques.maxRow"
                              :key="idx"
                              :style="bfColor(ques)"
                              :label="option.text"
                              :name="'radio-' + pageIndex + '-' + index"
                            >
                              <span
                                class="otherStr"
                                @click="handleShowDialog(ques)"
                                readonly="readonly"
                                v-if="option.checkedLabel && option.id === '98'"
                                >{{ ques.blankSetting[0].value }}</span
                              >
                              <p
                                :class="{
                                  radioContent: true,
                                  radioContentVote: ques.showVote
                                }"
                                v-html="option.text"
                              >
                                {{ option.text }}
                              </p>
                              <div v-if="ques.showVote" class="pull-right">
                                <span class="voteCountDisp"
                                  >{{
                                    (ques.voteCountMap[
                                      'voteCount' + SURVEY_ID + option.id
                                    ] || 0) + Number(option.checked)
                                  }}票</span
                                >
                                <span class="votePercDisp"
                                  >{{
                                    (
                                      (((ques.voteCountMap[
                                        'voteCount' + SURVEY_ID + option.id
                                      ] || 0) +
                                        Number(option.checked)) /
                                        (ques.countSum || 1)) *
                                      100
                                    ).toFixed(2)
                                  }}%</span
                                >
                              </div>
                            </el-radio>
                          </template>
                        </el-radio-group>
                      </div>
                    </div>

                    <div
                      :class="genOptionClass(ques)"
                      v-if="ques.type === 'checkbox'"
                    >
                      <p v-if="ques.isBeyond" class="unFinishedTips">
                        {{ '最多选择' + ques.maxLength + '项' }}
                      </p>
                      <div v-if="!ques.referFlag" class="checkbox-group">
                        <el-checkbox
                          :class="'row-' + ques.maxRow"
                          :key="index"
                          v-for="(option, index) in ques.options"
                          v-model="option.checked"
                          :style="bfColor(ques)"
                          @change="handleCheck(ques, index, option)"
                        >
                          <span
                            class="otherStr checkboxOther"
                            @click="handleShowDialog(ques)"
                            readonly="readonly"
                            v-if="option.checked && option.id === '98'"
                            >{{ ques.blankSetting[0].value }}</span
                          >
                          <p
                            :class="{
                              radioContent: true,
                              radioContentVote: ques.showVote
                            }"
                            v-html="option.text"
                          >
                            {{ option.text }}
                          </p>
                          <div v-if="ques.showVote" class="pull-right">
                            <span class="voteCountDisp"
                              >{{
                                (ques.voteCountMap[
                                  'voteCount' + SURVEY_ID + option.id
                                ] || 0) + Number(option.checked)
                              }}票</span
                            >
                            <span class="votePercDisp"
                              >{{
                                (
                                  (((ques.voteCountMap[
                                    'voteCount' + SURVEY_ID + option.id
                                  ] || 0) +
                                    Number(option.checked)) /
                                    (ques.countSum || 1)) *
                                  100
                                ).toFixed(2)
                              }}%</span
                            >
                          </div>
                        </el-checkbox>
                      </div>
                      <div class="checkbox-group" v-else>
                        <span v-if="!ques.isAnswer"
                          >此题选项来源于{{
                            ques.referIndex
                          }}题中的选项，请先填写第{{ ques.referIndex }}题</span
                        >
                        <div v-else>
                          <template v-for="(option, index) in ques.options">
                            <el-checkbox
                              :class="'row-' + ques.maxRow"
                              :key="index"
                              v-model="option.checked"
                              v-if="option.display"
                              :style="bfColor(ques)"
                              @change="handleCheck(ques, index, option)"
                            >
                              <span
                                class="otherStr checkboxOther"
                                @click="handleShowDialog(ques)"
                                readonly="readonly"
                                v-if="option.checked && option.id === '98'"
                                >{{ ques.blankSetting[0].value }}</span
                              >
                              <p
                                :class="{
                                  radioContent: true,
                                  radioContentVote: ques.showVote
                                }"
                                v-html="option.text"
                              >
                                {{ option.text }}
                              </p>
                              <div v-if="ques.showVote" class="pull-right">
                                <span class="voteCountDisp"
                                  >{{
                                    (ques.voteCountMap[
                                      'voteCount' + SURVEY_ID + option.id
                                    ] || 0) + Number(option.checked)
                                  }}票</span
                                >
                                <span class="votePercDisp"
                                  >{{
                                    (
                                      (((ques.voteCountMap[
                                        'voteCount' + SURVEY_ID + option.id
                                      ] || 0) +
                                        Number(option.checked)) /
                                        (ques.countSum || 1)) *
                                      100
                                    ).toFixed(2)
                                  }}%</span
                                >
                              </div>
                            </el-checkbox>
                          </template>
                        </div>
                      </div>
                    </div>
                    <div v-if="ques.type === 'textarea'">
                      <el-form
                        status-icon
                        ref="ques"
                        class="textAreaTooltip"
                        :rules="textareValidateRules"
                        :model="ques"
                      >
                        <p class="toolTipShow"></p>
                        <el-form-item prop="texts">
                          <el-input
                            v-if="ques.title.indexOf('问卷id') > -1 && BBID"
                            type="textarea"
                            :rows="1"
                            placeholder="请输入内容"
                            v-model="ques.texts"
                            resize="none"
                            :disabled="isBBSurvey"
                          ></el-input>
                          <el-input
                            v-else
                            type="textarea"
                            :rows="ques.rows"
                            placeholder="请输入内容"
                            v-model="ques.texts"
                            @input="handleInputText(ques)"
                            @focus="handleFocusText(ques, $event)"
                            @blur="handleBlurText(ques)"
                            @change="handleInput(ques)"
                            resize="none"
                          ></el-input>
                        </el-form-item>
                      </el-form>
                    </div>
                    <div v-if="ques.type === 'date'">
                      <div v-if="!ques.style">
                        <div v-if="winWidth > divideVal">
                          <el-date-picker
                            v-model="ques.texts"
                            type="date"
                            :editable="false"
                            placeholder="选择日期"
                            value-format="yyyy-MM-dd"
                            @focus="doBlur"
                            @change="handleDateSelect(ques)"
                          ></el-date-picker>
                        </div>
                        <div v-else class="el-select">
                          <el-select
                            readonly="readonly"
                            autocomplete="off"
                            class="el-input--prefix"
                            placeholder="选择日期"
                            v-model="ques.texts"
                            @focus="doBlur"
                            @click.native="showCascadePicker(ques)"
                          ></el-select>
                          <span class="el-input__prefix">
                            <i class="el-input__icon el-icon-date"></i>
                          </span>
                        </div>
                      </div>
                      <div v-if="ques.style && ques.style[0] === 'y'">
                        <div v-if="winWidth > divideVal">
                          <el-date-picker
                            v-model="ques.texts"
                            type="year"
                            :editable="false"
                            placeholder="选择年份"
                            value-format="yyyy"
                            @focus="doBlur"
                            @change="handleDateSelect(ques)"
                          ></el-date-picker>
                        </div>
                        <div v-else class="el-select">
                          <el-select
                            readonly="readonly"
                            autocomplete="off"
                            class="el-input--prefix"
                            placeholder="选择年份"
                            v-model="ques.texts"
                            @focus="doBlur"
                            @click.native="showCascadePicker(ques)"
                          ></el-select>
                          <span class="el-input__prefix">
                            <i class="el-input__icon el-icon-date"></i>
                          </span>
                        </div>
                      </div>
                    </div>
                    <div v-if="ques.type === 'region'">
                      <div v-if="winWidth > divideVal">
                        <el-cascader
                          :options="regionOptions"
                          :editable="false"
                          @focus="doBlur"
                          @change="handleRegionSelect(ques)"
                          v-model="ques.blankSetting"
                          placeholder="选择区域"
                        ></el-cascader>
                      </div>
                      <div v-else class="el-select">
                        <el-select
                          readonly="readonly"
                          autocomplete="off"
                          placeholder="选择区域"
                          v-model="ques.region_m"
                          @click.native="showCascadePicker(ques)"
                        ></el-select>
                      </div>
                    </div>
                    <div v-if="ques.type === 'star'" class="clear-fix">
                      <div
                        class="starRadios clear-fix mobile-radio"
                        v-if="!ques.revertSort"
                      >
                        <span class="starText">{{
                          ques.starType !== 5
                            ? '非常不' + starMap[ques.starType]
                            : ques.starShowCustomStart
                        }}</span>
                        <el-radio
                          @change="handleCheckStar(ques)"
                          @focus="doBlur"
                          v-model="ques.checkedStar"
                          class="starRadio"
                          :key="i"
                          :label="ques.starBeginNum + i - 1"
                          v-for="i in ques.starNum"
                          >{{ ques.starBeginNum + i - 1 }}</el-radio
                        >
                        <span class="starText end">{{
                          ques.starType !== 5
                            ? '非常' + starMap[ques.starType]
                            : ques.starShowCustomEnd
                        }}</span>
                      </div>
                      <div class="starRadios clear-fix mobile-radio" v-else>
                        <span class="starText">{{
                          ques.starType !== 5
                            ? '非常' + starMap[ques.starType]
                            : ques.starShowCustomEnd
                        }}</span>
                        <el-radio
                          @change="handleCheckStar(ques)"
                          @focus="doBlur"
                          v-model="ques.checkedStar"
                          class="starRadio"
                          :key="i"
                          :label="ques.starBeginNum + ques.starNum - i"
                          v-for="i in ques.starNum"
                          >{{ ques.starBeginNum + ques.starNum - i }}</el-radio
                        >
                        <span class="starText end">{{
                          ques.starType !== 5
                            ? '非常不' + starMap[ques.starType]
                            : ques.starShowCustomStart
                        }}</span>
                      </div>
                    </div>
                    <div v-if="ques.type === 'select'">
                      <div v-if="!ques.referFlag">
                        <div v-if="winWidth > divideVal">
                          <el-select
                            v-model="ques.checkedLabel"
                            @change="handleSelectChange(ques)"
                            @focus="doBlur"
                          >
                            <el-option
                              v-for="(option, index) in ques.options"
                              :key="index"
                              :label="option.text"
                              :value="option.text"
                            ></el-option>
                          </el-select>
                        </div>
                        <div v-else class="el-select">
                          <el-select
                            readonly="readonly"
                            autocomplete="off"
                            placeholder="请选择"
                            v-model="ques.checkedLabel"
                            @click.native="showCascadePicker(ques)"
                          ></el-select>
                        </div>
                      </div>
                      <div v-else>
                        <span v-if="!ques.isAnswer"
                          >此题选项来源于{{
                            ques.referIndex
                          }}题中的选项，请先填写第{{ ques.referIndex }}题</span
                        >
                        <el-select
                          v-else
                          v-model="ques.checkedLabel"
                          @change="handleSelectChange(ques)"
                          @focus="doBlur"
                        >
                          <el-option
                            v-for="(option, index) in ques.checkedArr"
                            v-show="option.display"
                            :key="index"
                            :label="option.text"
                            :value="option.text"
                          ></el-option>
                        </el-select>
                      </div>
                    </div>
                    <div v-if="ques.type === 'sort'">
                      <div v-if="!ques.referFlag">
                        <div>Tips:按顺序点击选项进行排序</div>
                        <el-row>
                          <sort :ques="ques" @end="handleSortEnd"></sort>
                        </el-row>
                      </div>
                      <div v-else>
                        <span v-if="!ques.isAnswer"
                          >此题选项来源于{{
                            ques.referIndex
                          }}题中的选项，请先填写第{{ ques.referIndex }}题</span
                        >
                        <div v-else>
                          <el-row>
                            <sort :ques="ques" @end="handleSortEnd"></sort>
                          </el-row>
                        </div>
                      </div>
                    </div>
                    <div v-if="ques.type === 'description'">
                      <p
                        class="ques-title ques-title-description"
                        v-html="ques.title"
                      ></p>
                    </div>
                    <div v-if="ques.type === 'upload'">
                      <upload
                        :ques="ques"
                        @fileChange="handleFileChange"
                      ></upload>
                    </div>
                    <div v-if="ques.type === 'matrixRadio'">
                      <div v-if="!ques.referFlag">
                        <div class="inputs">
                          <div class="matrix-group table-scoll">
                            <table class="table_freezed">
                              <thead>
                                <tr>
                                  <th class="option_choose"></th>
                                  <th
                                    class="option_title"
                                    v-for="(opt, index) in ques.options"
                                    :key="index"
                                  >
                                    <p>{{ opt.text }}</p>
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr
                                  v-for="(title, idx) in ques.subTitles"
                                  :key="idx"
                                >
                                  <th class="sub_title">
                                    <div
                                      class="subtitle_text"
                                      style="visibility: hidden"
                                    >
                                      {{ title.text }}
                                    </div>
                                  </th>
                                  <td
                                    class="option_choose"
                                    v-for="(opt, index) in ques.options"
                                    :key="index"
                                  >
                                    <el-radio
                                      v-model="title.checked"
                                      @change="handleMatrixRadioCheck(ques)"
                                      :label="opt.id"
                                    ></el-radio>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                          <table class="matrix_group_mirror">
                            <thead>
                              <tr>
                                <td style="height: 22px"></td>
                              </tr>
                            </thead>
                            <tbody>
                              <tr
                                v-for="(title, idx) in ques.subTitles"
                                :key="idx"
                              >
                                <td class="sub_title">
                                  <div class="subtitle_text">
                                    {{ title.text }}
                                  </div>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                      <div v-else>
                        <span v-if="!ques.isAnswer"
                          >此题子问题来源于{{
                            ques.referIndex
                          }}题中的选项，请先填写第{{ ques.referIndex }}题</span
                        >
                        <div>
                          <div class="inputs">
                            <div class="matrix-group table-scoll">
                              <table class="table_freezed">
                                <thead>
                                  <tr>
                                    <td></td>
                                    <th
                                      class="option_title"
                                      v-for="opt in ques.options"
                                      :key="opt.id"
                                    >
                                      <p>{{ opt.text }}</p>
                                    </th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr
                                    v-for="(title, idx) in ques.subTitles"
                                    :key="idx"
                                  >
                                    <th class="sub_title">
                                      <div class="subtitle_text">
                                        {{ title.text }}
                                      </div>
                                    </th>
                                    <td
                                      class="option_choose"
                                      v-for="opt in ques.options"
                                      :key="opt.id"
                                    >
                                      <el-radio
                                        v-model="title.checked"
                                        @change="handleMatrixRadioCheck(ques)"
                                        :label="opt.id"
                                      ></el-radio>
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                            <table class="matrix_group_mirror">
                              <thead>
                                <tr>
                                  <td style="height: 22px"></td>
                                </tr>
                              </thead>
                              <tbody>
                                <tr
                                  v-for="(title, idx) in ques.subTitles"
                                  :key="idx"
                                >
                                  <td class="sub_title">
                                    <div class="subtitle_text">
                                      {{ title.text }}
                                    </div>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div v-if="ques.type === 'matrixCheckbox'">
                      <div v-if="!ques.referFlag">
                        <div class="inputs">
                          <div class="matrix-group table-scoll">
                            <table class="table_freezed">
                              <thead>
                                <tr>
                                  <td></td>
                                  <th
                                    class="option_title"
                                    v-for="opt in ques.options"
                                    :key="opt.id"
                                  >
                                    <p>{{ opt.text }}</p>
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr
                                  v-for="(title, idx) in ques.subTitles"
                                  :key="idx"
                                >
                                  <th class="sub_title">
                                    <div
                                      class="subtitle_text"
                                      style="visibility: hidden"
                                    >
                                      {{ title.text }}
                                    </div>
                                  </th>
                                  <td :colspan="ques.options.length">
                                    <el-checkbox-group
                                      v-model="title.checked"
                                      @change="handleMatrixCheckbox(ques)"
                                    >
                                      <el-checkbox
                                        v-for="opt in ques.options"
                                        :label="opt.id"
                                        :key="opt.id"
                                        class="option_choose"
                                      ></el-checkbox>
                                    </el-checkbox-group>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                          <table class="matrix_group_mirror">
                            <thead>
                              <tr>
                                <td style="height: 22px"></td>
                              </tr>
                            </thead>
                            <tbody>
                              <tr
                                v-for="(title, idx) in ques.subTitles"
                                :key="idx"
                              >
                                <td class="sub_title">
                                  <div class="subtitle_text">
                                    {{ title.text }}
                                  </div>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                      <div v-else>
                        <span v-if="!ques.isAnswer"
                          >此题子问题来源于{{
                            ques.referIndex
                          }}题中的选项，请先填写第{{ ques.referIndex }}题</span
                        >
                        <div class="inputs">
                          <div class="matrix-group table-scoll">
                            <table class="table_freezed">
                              <thead>
                                <tr>
                                  <td></td>
                                  <th
                                    class="option_title"
                                    v-for="opt in ques.options"
                                    :key="opt.id"
                                  >
                                    <p>{{ opt.text }}</p>
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr
                                  v-for="(title, idx) in ques.subTitles"
                                  :key="idx"
                                >
                                  <th class="sub_title">
                                    <div class="subtitle_text">
                                      {{ title.text }}
                                    </div>
                                  </th>
                                  <td :colspan="ques.options.length">
                                    <el-checkbox-group
                                      v-model="title.checked"
                                      @change="handleMatrixCheckbox(ques)"
                                    >
                                      <el-checkbox
                                        v-for="opt in ques.options"
                                        :label="opt.id"
                                        :key="opt.id"
                                        class="option_choose"
                                      ></el-checkbox>
                                    </el-checkbox-group>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                          <table class="matrix_group_mirror">
                            <thead>
                              <tr>
                                <td style="height: 22px"></td>
                              </tr>
                            </thead>
                            <tbody>
                              <tr
                                v-for="(title, idx) in ques.subTitles"
                                :key="idx"
                              >
                                <td class="sub_title">
                                  <div class="subtitle_text">
                                    {{ title.text }}
                                  </div>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                    <div
                      v-if="ques.type === 'matrixStar'"
                      style="position: relative"
                    >
                      <div v-if="!ques.referFlag">
                        <div class="matrix-starRadios matrix-disp">
                          <div class="matrix-title">
                            <p class="matrix-star-text">
                              <span class="matrix-starText">{{
                                ques.starType !== 5
                                  ? '不' + starMap[ques.starType]
                                  : ques.starShowCustomStart
                              }}</span>
                              <span class="matrix-starText">{{
                                ques.starType !== 5
                                  ? starMap[ques.starType]
                                  : ques.starShowCustomEnd
                              }}</span>
                            </p>
                          </div>
                          <div
                            class="matrix-star-sub"
                            v-for="(item, index) in ques.subTitles"
                            :key="index"
                          >
                            <div class="star-sub-title pull-left">
                              {{ removeLables(item.text) }}
                            </div>
                            <el-slider
                              :class="{
                                'slider-star': true,
                                'active-star': !(
                                  typeof item.activeFlag === 'undefined'
                                )
                              }"
                              v-model="item.checkedStar"
                              @change="handleMatrixStarChange(ques, index)"
                              :step="1"
                              show-stops
                              :show-tooltip="true"
                              :min="ques.starBeginNum"
                              :max="ques.starNum + ques.starBeginNum - 1"
                            ></el-slider>
                          </div>
                        </div>
                      </div>
                      <div v-else>
                        <span v-if="!ques.isAnswer"
                          >此题子问题来源于{{
                            ques.referIndex
                          }}题中的选项，请先填写第{{ ques.referIndex }}题</span
                        >
                        <div v-else class="matrix-starRadios matrix-disp">
                          <p class="matrix-star-text matrix-title">
                            <span class="matrix-starText">{{
                              ques.starType !== 5
                                ? '不' + starMap[ques.starType]
                                : ques.starShowCustomStart
                            }}</span>
                            <span class="matrix-starText">{{
                              ques.starType !== 5
                                ? starMap[ques.starType]
                                : ques.starShowCustomEnd
                            }}</span>
                          </p>
                          <template v-for="(item, index) in ques.subTitles">
                            <div
                              v-if="item.display"
                              class="matrix-star-sub"
                              :key="index"
                            >
                              <div class="star-sub-title pull-left">
                                {{ removeLables(item.text) }}
                              </div>
                              <el-slider
                                class="slider-star"
                                v-model="item.checkedStar"
                                @change="handleMatrixStarChange(ques, index)"
                                :step="1"
                                :min="ques.starBeginNum"
                                :max="ques.starNum + ques.starBeginNum - 1"
                              ></el-slider>
                            </div>
                          </template>
                        </div>
                      </div>
                    </div>
                    <div v-if="ques.type === 'chainedSelects'">
                      <chained-selects
                        :ques="ques"
                        @finish="handleCSFinish(ques)"
                      ></chained-selects>
                    </div>
                    <div v-if="ques.type === 'evaluate'">
                      <evaluate :ques="ques"></evaluate>
                    </div>
                    <div v-if="ques.type === 'nps'">
                      <nps :ques="ques" :themeColor = 'themeColor'></nps>
                    </div>
                  </div>
                </el-form>
              </div>
            </template>
            <div
              :class="['nextBtn', { 'is-radius': submitBtnText.radius === 1 }]"
            >
              <div v-if = 'isSupportTouch === 0'>
                <el-button
                  v-if="linkToEnd || linkToNewUrl"
                  type="primary"
                  class="mobile-btn submit"
                  @click="handleSubmitEnd"
                  :disabled="!legal.defaultCheck"
                  v-show="isShowCtrl('hideSubmitButton')"
                >
                  {{ submitBtnText.text }}
                </el-button>
                <el-button
                  v-else-if="activePage == survey.pages.length - 1"
                  type="primary"
                  class="mobile-btn submit"
                  :disabled="!legal.defaultCheck"
                  @click="handleSubmitSurvey"
                  v-show="isShowCtrl('hideSubmitButton')"
                >
                  {{ submitBtnText.text }}
                </el-button>
                <el-button
                  v-else
                  type="primary"
                  class="mobile-btn"
                  @click="handleNext"
                >
                  下一页
                </el-button>
              </div>
              <div v-else-if = 'isSupportTouch === 1'>
                <el-button
                  v-if="linkToEnd || linkToNewUrl"
                  type="primary"
                  class="mobile-btn submit"
                  @touchstart.native="handleSubmitEnd"
                  :disabled="!legal.defaultCheck"
                  v-show="isShowCtrl('hideSubmitButton')"
                >
                  {{ submitBtnText.text }}
                </el-button>
                <el-button
                  v-else-if="activePage == survey.pages.length - 1"
                  type="primary"
                  class="mobile-btn submit"
                  :disabled="!legal.defaultCheck"
                  @touchstart.native="handleSubmitSurvey"
                  v-show="isShowCtrl('hideSubmitButton')"
                >
                  {{ submitBtnText.text }}
                </el-button>
                <el-button
                  v-else
                  type="primary"
                  class="mobile-btn"
                  @touchstart.native.prevent.stop="handleNext"
                >
                  下一页
                </el-button>
              </div>
            </div>
            <div class="agreement" v-show="isShowCtrl('addLegalAgreement')">
              <el-checkbox v-model="legal.defaultCheck" size="mini" border>
                {{ legal.text }}
              </el-checkbox>
              <a class="legal-name" @click="openLegalModal">
                《{{ legal.agreementName }}》
              </a>
            </div>
          </div>
          <div
            class="survey-pages"
            :class="{
              active:
                survey.pages.length > 0 && activePage == survey.pages.length
            }"
          >
            <div class="endPage">
              <!-- <img
                v-if="
                  !oa && survey.suffix && survey.suffix.indexOf('<img') == -1
                "
                src="../assets/happy1.png"
              /> -->
              <p class="survey-inner" v-html="survey.suffix"></p>
              <!-- survey-1053105-score 这个class一次性，过了20250630后可去掉这个class和相关代码 -->
              <p v-if="surveyScore !== null" class="survey-score" :class="{'survey-1053105-score': SURVEY_ID == 1053105}">
                总得分：
                <span>{{ surveyScore }}</span>
              </p>
              <!-- <el-button
                class="create-btn"
                @click="handleCreate"
                v-show="isShowCtrl('hideEndPageButton')"
              >
                {{ endPageText }}
              </el-button> -->
            </div>
          </div>
        </div>
        <div v-if="survey.ipLimited" class="limitedTips">您已作答完毕</div>
        <div v-if="invalidate" class="limitedTips" v-loading="surveyLoading">
          请确认问卷链接是否有效
        </div>
      </div>
      <!-- <div
        class="bottom-text"
        :class="{
          active: survey.pages.length > 0 && activePage == survey.pages.length,
        }"
      >
        系统由58问卷提供
      </div> -->
      <div v-show="isShowCtrl('hideCopyRightOrAD')">
        <div class="bottom-text">系统由58问卷提供</div>
        <img
          class="pc-logo"
          :class="{
            active: survey.pages.length > 0 && activePage == survey.pages.length
          }"
          src="../assets/pc_logo@2x.png"
        />
      </div>
    </div>
    <div
      v-else
      class="survey-content survey-countDown-page"
      :class="{ 'survey-preview': SOURCE == 'pcPreview' }"
    >
      <div
        class="survey-wrap"
        :class="{ 'survey-preview': SOURCE == 'pcPreview' }"
        style="text-align: center"
      >
        <i class="clock-icon"></i>
        <p class="first-line">
          此问卷将于
          <span>{{ recyleStartTime }}</span
          >开放
        </p>
        <p>请到时再重新打开此页面进行填写</p>
      </div>
    </div>
    <queDialog
      :dialogVisible="dialogVisible"
      :blankValue="tempBlankValue"
      @confirm="handleDialogConfirm"
    ></queDialog>
    <cube-popup type="extend-popup" ref="popup" position="bottom">
      <div class="cube-extend-popup-content" @click="hideLegalModal">
        <div class="header">
          {{ legal.agreementName
          }}<i class="el-icon-close" @click="hideLegalModal"></i>
        </div>
        <iframe
          v-if="
            survey.surveyAdvanceSettingObj &&
              survey.surveyAdvanceSettingObj.legalAgreementSetting
          "
          :src="
            survey.surveyAdvanceSettingObj.legalAgreementSetting.agreementUrl
          "
          frameborder="0"
          width="100%"
          class="legal-content"
        ></iframe>
      </div>
    </cube-popup>
  </div>
</template>

<script>
import { defaultThemeColor } from '@/utils/constant'
import { advanceMinxin, genAdvanceSettingFlag } from '@/utils/advanceMinxin'
import { Loading } from 'element-ui'
import draggable from 'vuedraggable'
import http from '../utils/http'
import validator from '../utils/constvlus'
import regionOptions from '../utils/regions'
import regionOptionsM from '../utils/regions-m'
import { rulesName, starMap } from '../utils/constant'
import queDialog from '../components/queDialog'
import {
  timeToLocal,
  uuid,
  winAlert,
  getParams,
  deepClone,
  getTitle,
  MSG,
  colorRgba
} from '../utils/utils'
import {
  upload,
  sort,
  chainedSelects,
  textMultiple,
  evaluate,
  nps
} from '../components/ques-widget'

import Hybrid from '@ajk/fe-hybrid-lib'
let driver = Hybrid()

let timer = null
export default {
  name: 'survey-new',
  mixins: [advanceMinxin],
  data() {
    return {
      headImg: '', // 是否显示头图
      interface: {
        getSurvey: '/survey', // 获取问卷
        answer: '/answer', // 提交接口
        tempAnswer: '/tempAnswer' // 临时提交接口
      },
      survey: {
        pages: [] // 问卷数据结构
      },
      starMap, // 打分类型文本
      activePage: 0, // 当前页
      nextPage: 1, // 下一页
      tempNextPage: 1, // 临时记录当前页的下一页下标
      startTime: new Date().getTime(), // 进入问卷页面时间
      finishCount: 0, // 填答完成数量
      controlArr: [], // 存储作答题目 [1,1,1,0,0] 1为需作答，0为不用作答，notvisible数组中的题目，不要作答，因此对应controlArr中为1
      unFinishedArr: [], // 未填答题目的数组
      linkToEnd: false, // 跳转到结束页
      linkToNewUrl: false, // 跳转到结束页隐藏其他题目
      linkUrl: '', // 跳转到新的链接
      toEndPerc: 0, // 填答完成百分比
      isCorrect: false, // 是否正常获取问卷内容打开
      invalidate: false, // 判断问卷是否有效
      surveyScore: null, // 问卷得分
      allQuestions: [], // 问卷所有题目
      isInValid: false, // 标记是否为无效问卷
      linkTo: '', // 跳转到的目标题目下标
      tempQues: {}, // 临时题目
      textareValidateRules: {
        // 文本校验
        texts: [{ validator: validator.validateInit, trigger: 'blur' }]
      },
      mulLinkMap: {}, // 多条件显示
      notVisible: [], // 显示跳转逻辑题目存放的数组，不可见数组 ,只要存入该数组中题目就不显示
      surveyLoading: false, // 加载loading
      phoneVaild: false, // 手机号码校验
      oa: getParams('oa'), // 获取到url请求参数中的oa字段内容
      regionOptions: regionOptions.regionJson, // 区域题数据结构
      regionOptionsM: regionOptionsM.regionJson, // 区域题数据结构 M端
      winHeight: getComputedStyle(document.getElementById('app')).height,
      winWidth: document.getElementById('app').offsetWidth,
      divideVal: 500,
      dialogVisible: false, // 输入dialog
      tempBlankValue: '', // dialog文本内容
      validateRulesName: rulesName, // 校验规则
      recyleStartStatus: false, // 问卷回收状态
      recyleStartTime: '', // 开始回收时间
      countdownTime: '5分钟', // 考试问卷倒计时
      showCountDownNotice: false, // 显示倒计时提示
      countdownTimer: null, // 倒计时定时器timer
      isBBSurvey: true, // 帮帮问卷标记，特殊处理
      themeColor: defaultThemeColor,
      isSupportTouch: 'ontouchend' in document ? 1 : 0,
      observer: null,
      targetSize: {
        width: 0,
        height: 0
      }
    }
  },
  components: {
    draggable,
    textMultiple,
    chainedSelects,
    sort,
    upload,
    queDialog,
    evaluate,
    nps
  },
  created() {
    if (window.location.href.indexOf('&amp;') > -1) {
      window.location.href = window.location.href.replace(/&amp;/g, '&') // 问卷链接有被转义过字符处理
      return
    }
    if (this.SURVEY_ID && this.HASH) {
      this.getSurvey() // 获取问卷信息
    } else {
      this.surveyLoading = false
    }
  },
  mounted() {
    if (
      !getParams('id') &&
      !getParams('hash') &&
      location.hostname === 'survey.58.com'
    ) {
      location.replace('https://wenjuan.58.com') // 如果问卷链接信息不足，直接重定向到外网问卷
      return
    }
    timer = window.setInterval(this.handleTempAnswer, 10000) // 每隔10s保存一次临时答案
    this.watchWindow()
    this.handleIframeMessage()
    this.pageResizeObserver()
    // 区域控件初始化
    this.addressPicker = this.$createCascadePicker({
      data: this.regionOptionsM,
      onSelect: this.selectHandle
    })
    // 日期控件
    this.setSelectPicker = this.$createCascadePicker({
      onSelect: this.selectHandle
    })
    // 手机app-webview-h5-iframe在苹果手机上的弹框特殊处理
    winAlert()
  },
  watch: {
    'survey.pages': {
      handler() {
        let count = 0
        this.survey.pages.forEach(page => {
          page.questions.forEach(ques => {
            if (
              ques.isFinish &&
              this.controlArr[ques.index] === 1 &&
              ques.required &&
              ques.type !== 'description'
            ) {
              count++
            }
          })
        })
        this.finishCount = count // 计算完成题目数量
      },
      deep: true
    },
    // 当前页
    activePage(val) {
      if (val == this.survey.pages.length) {
        this.hideCopyRight()
      }
    },
    type: {
      immediate: true,
      handler(val) {
        if (val == 'vr') {
          this.$nextTick(() => {
            this.hideCopyRight()
          })
        }
      }
    }
  },
  computed: {
    queList() {
      let ans = []
      this.survey.pages.forEach(page => {
        page.questions.forEach(ques => {
          ans.push(ques)
        })
      })
      return ans
    },
    bfColor: function() {
      return function(ques) {
        let obj = {}
        if (ques.addOptionColor && ques.fillColor) {
          obj['background-color'] = colorRgba(ques.fillColor, 0.2)
        }
        if (ques.addBorderColor && ques.borderColor) {
          obj['border-color'] = ques.borderColor
          if (ques.addOptionColor) {
            obj['border-color'] = colorRgba(ques.borderColor, 0.2)
          }
        }
        return obj
      }
    },
    // 获取问卷url查询参数中的字段
    SURVEY_ID() {
      return getParams('id')
    },
    HASH() {
      return getParams('hash')
    },
    BBID() {
      return getParams('BBID') // 客服帮帮业务字段，问卷特殊处理逻辑
    },
    SOURCE() {
      return getParams('source')
    },
    isSkinPreview() {
      return getParams('isSkin')
    },
    type() {
      return getParams('type')
    },
    quesSum() {
      // 问卷题目数量统计
      let sum = 0
      for (let i = 0; i < this.controlArr.length; i++) {
        if (this.allQuestions[i]) {
          const _ques = this.allQuestions[i].ques
          if (
            this.controlArr[i] === 1 &&
            _ques.required &&
            _ques.type !== 'description' // 段落题不计入数量
          ) {
            sum++
          }
        }
      }
      return sum || Infinity
    },
    // 题目完成数量
    percentage() {
      const perc = parseInt((this.finishCount / this.quesSum) * 100)
      return perc
    }
  },
  beforeDestroy() {
    if (this.observer && this.observer.close && typeof this.observer.close === 'function') {
      this.observer.close()
    }
  },
  methods: {
    genOptionClass(ques) {
      return [
        {
          'no-checkbox': ques.hideCheckBox,
          'has-border': ques.addBorderColor,
          'has-bg': ques.addOptionColor
        },
        'custom-color'
      ]
    },
    hideCopyRight() {
      document.getElementById('bottomText').style.display = 'none'
    },
    handleUseSkin() {
      window.location.href = `https://survey.58corp.com/m/survey#/edit?id=${this.SURVEY_ID}&hash=${this.HASH}`
    },
    // 区域题和日期题在M端和Pc端不通的ui交互处理逻辑
    showCascadePicker(ques) {
      this.tempQues = ques
      if (ques.type === 'select') {
        if (!ques.referFlag) {
          this.setSelectPicker.setData(ques.options)
          this.setSelectPicker.show()
        }
      } else if (ques.type === 'region') {
        this.addressPicker.show() // 区域题型显示
      } else if (ques.type === 'date') {
        if (ques.style && ques.style[0] === 'y') {
          // 显示样式包括年
          if (!this.yearPicker) {
            this.yearPicker = this.$createDatePicker({
              min: new Date(1900, 1, 1),
              max: new Date(2100, 1, 1),
              value: new Date(),
              columnCount: 1,
              onSelect: this.selectHandle
            })
          }
          this.yearPicker.show() // 日期题型显示
        } else {
          if (!this.datePicker) {
            this.datePicker = this.$createDatePicker({
              min: new Date(1900, 1, 1),
              max: new Date(2100, 1, 1),
              value: new Date(),
              onSelect: this.selectHandle
            })
          }
          this.datePicker.show()
        }
      }
      // 重写样式覆盖第三库的样式逻辑
      const pickerList = document.body.getElementsByClassName('cube-picker')
      const popperList = document.body.getElementsByClassName('el-popper')
      let timesRun = 0
      // 交互隐藏
      const interval = setInterval(() => {
        if (timesRun === 8) {
          clearInterval(interval)
        }
        for (let i = 0; i < popperList.length; i++) {
          popperList[i].style.display = 'none'
        }
        for (let i = 0; i < pickerList.length; i++) {
          pickerList[i].style.zIndex = 10000
        }
        timesRun += 1
      }, 20)
    },
    // 区域题和日期题选中逻辑
    selectHandle(selectedVal, selectedIndex, selectedText) {
      const ques = this.tempQues
      if (ques.type === 'select') {
        if (!ques.referFlag) {
          this.$set(ques, 'checkedLabel', selectedText[0])
          this.handleSelectChange(ques)
        }
      } else if (ques.type === 'region') {
        this.$set(ques, 'region_m', selectedVal.join('/'))
        ques.blankSetting = selectedVal
        this.handleRegionSelect(ques)
      } else if (ques.type === 'date') {
        this.$set(ques, 'texts', selectedText.join('-'))
        this.handleDateSelect(ques)
      }
    },
    watchWindow() {
      // 自适应宽度计算
      window.addEventListener('resize', () => {
        const app = document.getElementById('app')
        this.winWidth = app.offsetWidth
      })
    },
    // iframe适配逻辑
    handleIframeMessage() {
      window.addEventListener('message', e => {
        document.getElementsByTagName('body')[0].style.width = e.data
      })
    },
    handleFileChange(ques, opt) {
      for (const key in opt) {
        opt.hasOwnProperty(key) && this.$set(ques, key, opt[key])
      }
    },
    // 获取问卷信息
    getSurvey() {
      const loadingInstance = Loading.service({
        lock: true,
        text: '拼命加载中',
        background: 'rgba(0, 0, 0, 0.3)'
      })
      const _ctrlArr = []
      http
        .get(this.interface.getSurvey, {
          userName: this.oa || null,
          surveyId: this.SURVEY_ID,
          hash: this.HASH,
          source: window.name === 'preview_frame' ? 'preview' : null // 判断问卷来源是否是预览
        })
        .then(response => {
          const { code, data, message } = response.data
          if (code === 1) {
            this.isCorrect = true
            this.invalidate = false // 有效问卷标识
            const _survey = data
            document.title = getTitle(data.remarkName || data.title) // 根据问卷题目，显示问卷标题
            if (navigator && navigator.userAgent.includes('AJK/')) {
              driver.setTitle(document.title) // 解决嵌入安居客客户端无法同步顶部标题问题
            }
            _survey.pages.forEach((page, i) => {
              page.questions.forEach((ques, j) => {
                if (ques.type !== 'description') {
                  // 段落题不计入，只做展示
                  _ctrlArr.push(0)
                  this.allQuestions.push({
                    // 所有题目放入数组中，记录题目对应页和下标
                    ques,
                    pageIdx: i,
                    quesIdx: j
                  })
                }
                if (ques.type == 'matrixCheckbox') {
                  // 矩阵多选题
                  ques.subTitles.forEach(item => {
                    item.checked = []
                  })
                }
                if (
                  (ques.type === 'checkbox' || ques.type === 'radio') &&
                  !ques.blankSetting.length
                ) {
                  // 如果单选或多项 ques.blankSetting.length==0 ，98为其他选项,添加其他选项
                  ques.blankSetting.push({
                    attachId: '98'
                  })
                }
                if (
                  this.BBID &&
                  ques.type === 'textarea' &&
                  ques.title.indexOf('问卷id') > -1
                ) {
                  // 客服帮帮特使问卷处理，无需变更
                  ques.texts = this.BBID
                }
              })
            })
            this.controlArr = _ctrlArr // 记录作答的题目
            this.survey = Object.assign(
              {},
              {
                advanceSettingFlag: false,
                surveyAdvanceSettingObj: genAdvanceSettingFlag()
              },
              this.addCheckedToCheckbox(_survey)
            )
            let surveyAdvanceSettingObj = this.survey.surveyAdvanceSettingObj
            if (this.survey.advanceSettingFlag) {
              if (surveyAdvanceSettingObj) {
                this.headImg = surveyAdvanceSettingObj.headPig
                this.themeColor =
                  surveyAdvanceSettingObj.themeColor || defaultThemeColor
                this.setProperty(this.themeColor)
              }
            } else {
              this.headImg = ''
            }
            this.setLegal()
            const flag = this.isShowCtrl('hideCopyRightOrAD')
            if (!flag) {
              this.hideCopyRight()
            }
            if (this.isBottom) {
              document.getElementById('bottomText').style.minHeight = '140px'
            }
            this.preHandle() // 预处理问卷所有题目
            this.linkCtrl(-1)
            this.countdownEndTime() // 开启结束作答倒计时
          } else {
            this.invalidate = true
            if (
              message.indexOf('此问卷将于') > -1 &&
              data &&
              data.recyleStartStatus &&
              data.recyleStartTime
            ) {
              // 回收时间提示
              this.recyleStartStatus = data.recyleStartStatus
              this.recyleStartTime = timeToLocal(
                new Date(data.recyleStartTime)
              ).datetime
            } else {
              MSG.error(message)
            }
          }
          loadingInstance.close()
          setTimeout(() => {
            let checkedbrowser = document.querySelectorAll(
              'input[type="radio"]'
            )
            for (let i = 0; i < checkedbrowser.length; i++) {
              checkedbrowser[i].checked = false
            }
          })
        })
        .catch(error => {
          this.invalidate = true
          loadingInstance.close()
          MSG.error(error)
        })
    },
    setProperty(themeColor) {
      let style = document.body.style
      let arr = [0.1, 0.2, 1]
      for (let index = 0; index < arr.length; index++) {
        let name = '--themeColor'
        if (arr[index] != 1) {
          name += '-light-' + arr[index] * 10
        }
        style.setProperty(name, colorRgba(themeColor, arr[index]))
      }
    },
    // 考试问卷倒计时，根据考试开始时间，结束时间进行倒计时交互处理
    countdownEndTime() {
      if (window.name === 'preview_frame') return
      const self = this
      const settings = this.survey.settings
      const endTime = settings.recyleEndTime
      if (settings.recyleStatus && endTime) {
        const date = endTime.replace(/-/g, '/')
        const _endTime = new Date(date).getTime()
        this.countdownTimer = setInterval(() => {
          // 定时每隔1s交互倒计时提示
          const now = new Date().getTime()
          const interval = parseInt(_endTime - now) / 1000
          if (interval <= 0) {
            self.countdownTime = `问卷已停止回收`
            window.clearInterval(self.countdownTimer)
            self.countdownTimer = null
            self.showCountDownNotice = true
          } else if (interval <= 300) {
            const minute = parseInt(interval / 60)
            const second = parseInt(interval % 60)
            self.countdownTime = `距离问卷停止回收还有${
              minute > 0 ? `${minute}分` : ''
            }${second < 10 ? `0${second}` : second}秒，请抓紧时间作答`
            self.showCountDownNotice = true
          }
        }, 1000)
      }
    },

    addCheckedToCheckbox(_survey) {
      _survey.pages.forEach(page => {
        page.questions.forEach(ques => {
          if (ques.type === 'checkbox') {
            ques.options.forEach(opt => {
              opt.checked = false
            })
          }
        })
      })
      return deepClone(_survey)
    },
    // 多选题选中事件
    handleCheck(ques, index, option) {
      const self = this
      let count = 0 // 记录选中个数
      const temp = ques // 记录题目
      const exclusiveFlag = ques.exclusive // 题目编辑-高级设置-选项互斥
      const isExclusive = ques.options[index].exclusive
      // const isBeyond = false // 题目编辑-高级设置-最多可选
      // const tempOptions = deepClone(ques.options)
      if (exclusiveFlag) {
        // 处理互斥选项逻辑
        ques.options.forEach((val, idx) => {
          if (isExclusive && exclusiveFlag) {
            // 含有互斥逻辑
            if (idx !== index) val.checked = false
          } else if (val.exclusive) val.checked = false
        })
      }
      const checkedArr = [] // 选中选项的数组、记录选项序号
      const checkedOptions = [] // 选中选项的数组、记录选项内容
      ques.options.forEach((val, i) => {
        // 记已选总数并保存idx
        if (val.checked) {
          count++
          checkedArr.push(i)
          checkedOptions.push(val)
        }
        // 多条件显示添加逻辑
        if (val.mulKey !== '') {
          if (val.checked) {
            // 记录
            self.mulLinkMap[val.mulKey] = val.mulToQues
          } else {
            // 否则，清空
            delete self.mulLinkMap[val.mulKey]
          }
        }
        // 显示逻辑
        self.changeVisible(val)
      })
      // 根据选中的选项更新显示逻辑
      checkedOptions.forEach(self.changeVisible)
      // 判断最多选择n项逻辑,超出则提示
      if (count > ques.maxLength && ques.maxLength > 0) {
        self.$message({
          message: `最多选择${ques.maxLength}项`,
          type: 'warning',
          customClass: 'showIsSubmit',
          showClose: true
        })
        ques.isBeyond = true // 超过提示
        ques.options[index].checked = false
        return false
      }
      ques.isBeyond = false // 否则取消提示
      if (option.id == '98' && option.checked) {
        // 其他选项id为98，弹框输入文本
        this.handleShowDialog(ques)
      }

      // 处理投票题
      ques.options.forEach(val => {
        if (ques.showStat) {
          // 投票题结果展示
          let sum = 0
          ques.showVote = true
          for (const val of Object.values(ques.voteCountMap)) {
            sum += val
          }
          ques.countSum = sum + count // 显示数量
        }
      })

      // 多选题跳转
      if (ques.goto !== '-1' && count > 0) {
        self.linkTo = +ques.goto // 有跳转
      } else {
        self.linkTo = ''
      }

      // 处理选项引用
      if (ques.referFlag || !ques.referFlag) {
        const pages =
          typeof this.survey !== 'undefined' ? this.survey.pages : []
        let _checkedText = [],
          checkArr = []
        checkedOptions.forEach((item, index) => {
          if (item.checked) {
            // 将选中的文本添加到数组_checkedText中
            const tex = this.removeLables(item.text)
            _checkedText.push(tex)
            checkArr.push(
              Object.assign({}, item, {
                display: true,
                checked: false,
                text: this.removeLables(tex)
              })
            )
          }
        })
        for (let i = 0; i < pages.length; i++) {
          pages[i].questions.forEach((item, index) => {
            const { refer, type, referFlag } = item
            if (refer === ques.id && referFlag) {
              // 矩阵单选、矩阵多选、矩阵打分题含有引用逻辑的处理
              switch (type) {
                case 'matrixRadio':
                case 'matrixCheckbox':
                case 'matrixStar':
                  {
                    const referOptions = this.getReferOptions(
                      _checkedText,
                      item
                    )
                    this.$set(item, 'subTitles', referOptions) // 题目编辑-高级设置-引用，选中后展示的引用选项
                  }
                  break
                default: {
                  if (!item.subTitles) {
                    const opts = deepClone(ques.options).map(val =>
                      // val.checked = false;
                      // TODO 引用逻辑问题
                      ({
                        checked: false,
                        goto: '',
                        id: val.id,
                        mulKey: '',
                        mulToQues: [],
                        mulToQuesId: [],
                        noRandom: false,
                        text: val.text,
                        toPage: -1,
                        toQues: 0,
                        visible: []
                      })
                    )
                    this.$set(item, 'subTitles', opts) // 题目编辑-高级设置-引用，选中后展示的引用选项
                  }
                  const referOptions = this.getReferOptions(_checkedText, item)
                  this.$set(item, 'options', referOptions) // 其他选中后展示的引用选项
                }
              }
              item.isAnswer = _checkedText.length > 0 // 记录作答状态
              item.checkedLength = _checkedText.length
            }
          })
        }
      }
      // 可能被其他题引用
      this.linkCtrl(ques.index)
      // 多条件显示触发逻辑
      if (self.mulLinkMap[`${ques.index}-${checkedArr.join(',')}`]) {
        // 根据规则判断多条件是否存在
        temp.hasMulFlag = true
        const _arr = self.mulLinkMap[`${ques.index}-${checkedArr.join(',')}`]
        temp.mulTo = []
        _arr.forEach(idx => {
          if (self.notVisible.indexOf(idx) > -1) {
            // 根据多条件跳转逻辑，更新不显示数组
            self.notVisible.splice(self.notVisible.indexOf(idx), 1)
            temp.mulTo.push(idx)
          }
        })
        self.linkCtrl(ques.index)
      } else if (temp.hasMulFlag) {
        // 清除已添加的多条件逻辑
        temp.mulTo.forEach(val => {
          // 根据多条件跳转逻辑，更新不显示数组
          if (self.notVisible.indexOf(val) === -1) {
            self.notVisible.push(val)
          }
        })
        temp.mulTo = []
        self.linkTo = ''
        self.linkCtrl(ques.index)
      }
      temp.isFinish = !!count
      Object.assign(ques, deepClone(temp, {}))
    },
    // 显示逻辑
    changeVisible(val) {
      if (val.visible.length > 0) {
        if (val.checked) {
          // 如果选中
          val.visible.forEach(item => {
            // 选中，该选项关联的跳转-显示逻辑-  不显示题目数组，将目标题目移除，变为可显示
            if (this.notVisible.indexOf(item) > -1) {
              this.notVisible.splice(this.notVisible.indexOf(item), 1)
            }
          })
        } else {
          // 未选中，该选项关联的跳转-显示逻辑-  目标题目添加到不显示题目数组中
          val.visible.forEach(item => {
            if (this.notVisible.indexOf(item) === -1) {
              this.notVisible.push(item)
            }
          })
        }
      }
    },
    // 处理引用的题目选项
    getReferOptions(checkedText, ques) {
      if (!ques.tempOptions) {
        // 题目编辑-高级设置-引用
        const arr = ques.subTitles || ques.options
        ques.tempOptions = deepClone(arr)
      }
      const subTitles = ques.tempOptions.filter(
        e => checkedText.indexOf(this.removeLables(e.text)) > -1
      )
      // 显示选中的引用选项
      subTitles.forEach(item => {
        item.display = true
      })
      return subTitles
    },
    isFinished(func) {
      let count = 0
      // 遍历所有题目
      this.survey.pages[this.activePage].questions.forEach(val => {
        let isFinish = true
        const flag = val.required && this.controlArr[val.index] === 1
        const type = val.type
        const typeList = [
          'radio',
          'textarea',
          'star',
          'matrixRadio',
          'matrixCheckbox',
          'matrixStar',
          'chainedSelects',
          'select',
          'sort',
          'upload',
          'textMultiple',
          'date',
          'region',
          'evaluate',
          'nps'
        ]
        if (type === 'checkbox') {
          const isChecked = val.options.some(opt => opt.checked)
          if (!isChecked && flag) isFinish = false
        }
        if (!val.isFinish && flag && typeList.indexOf(type) > -1) {
          isFinish = false
        }
        const index = this.unFinishedArr.indexOf(val.realIndex)
        // 未完成页面跳到未完成题目处
        if (!isFinish) {
          count++
          if (count === 1) {
            window.scrollTo(
              0,
              +this.$refs[`ques_${val.realIndex}`][0].offsetTop
            )
          }
          if (index === -1) this.unFinishedArr.push(val.realIndex)
        } else if (val.type !== 'description') {
          if (index > -1) this.unFinishedArr.splice(index, 1)
        }
      })
      if (count > 0) {
        if (
          this.SURVEY_ID == '1007034' &&
          /iPhone|iPad|iPod/.test(navigator.userAgent)
        ) {
          alert('请先完成本页所有必填问题') // 部落问卷1007034 的特殊处理，适配手机app中H5使用iframe交互问题
        } else {
          this.$message({
            message: '请先完成本页所有必填问题',
            type: 'warning',
            customClass: 'show-message',
            showClose: true
          })
        }
        return
      }
      func && func()
    },
    // 跳到下一页
    handleNext() {
      const self = this
      this.isFinished(() => {
        const nextPage = self.survey.pages[self.nextPage] // 当前页填答完成跳转到下一页
        if (nextPage && nextPage.questions.length > 0) {
          const nextPageLength = nextPage.questions.length
          const nextPageIdx = nextPage.questions[0].index
          let emptyFlag = true
          for (let i = 0; i < nextPageLength; i++) {
            // 如果下一页题目不需作答，直接跳过
            if (self.controlArr[nextPageIdx + i] === 1) {
              emptyFlag = false
              break
            }
          }
          if (emptyFlag) {
            // 直接跳过
            self.nextPage++
          }
        }
        self.activePage = self.nextPage // 当前页为切到下一页
        self.scrollTop() // 滚到到顶部
        self.nextPage++
        self.tempNextPage = self.nextPage
      })
    },
    // 提交
    handleSubmitEnd() {
      if (this.linkToNewUrl) {
        window.location.href = this.linkUrl
      } else {
        this.handleTempAnswer()
        this.handleSubmit()
        this.activePage = this.survey.pages.length
      }
    },
    // 提交校验判断
    handleSubmitSurvey() {
      const _ = this
      this.isFinished(() => {
        if (
          typeof _.$refs.ques === 'undefined' ||
          _.$refs.ques.length === 0 ||
          this.$data.phoneVaild
        ) {
          _.handleTempAnswer()
          _.handleSubmit()
        } else {
          const forms = _.$refs.ques
          const form = forms[forms.length - 1]
          form.validate(valid => {
            if (valid) {
              _.handleTempAnswer()
              _.handleSubmit()
            }
          })
        }
      })
    },
    // 提交
    handleSubmit() {
      this.isFinished(() => {
        if (window.name === 'preview_frame') {
          this.activePage++
          alert('预览状态作答将不被保存!')
          return
        }
        if (this.SOURCE == 'wapPreview') {
          this.activePage++
          alert('预览状态下添加数据不被记录!')
          return
        }
        if (this.survey.status === 2) {
          // 状态2为暂停回收
          this.showCountDownNotice = false
          this.activePage++
          this.$message({
            duration: 3000,
            type: 'error',
            message: '该问卷已暂停回收,提交将不记录数据'
          })
          return
        }
        let pages = [],
          tempPage
        let tempQues = this._data.tempQues
        // 处理作答题目答案为提交的数据结构
        this.survey.pages.forEach(val => {
          tempPage = {
            id: val.id,
            questions: []
          }
          val.questions.forEach((ques, i) => {
            if (this.controlArr[ques.index] === 0) return true
            tempQues = {
              id: ques.id,
              type: ques.type,
              text:
                ques.checkedStar !== undefined
                  ? `${ques.checkedStar}`
                  : ques.texts || '',
              options: ques.type.indexOf('matrix') === -1 ? [] : null,
              groups: ques.type.indexOf('matrix') > -1 ? [] : null,
              blanks: ques.type === 'region' ? [] : ques.blankSetting,
              assess: ques.assess || null
            }
            if (ques.type === 'region') {
              // 区域题
              tempQues.text = ques.blankSetting.join(',')
            } else if (ques.type === 'evaluate' || ques.type === 'nps') {
              // 评价题
              Object.assign(tempQues, ques.answer)
            } else if (ques.type === 'sort') {
              // 排序题
              ques.options.forEach(opt => {
                tempQues.options.push({
                  id: opt.id,
                  sortNo: opt.sortNo,
                  text: opt.text
                })
              })
              let num = 1
              if (ques.checkedArr) {
                //
                for (let i = 0; i < tempQues.options.length; i++) {
                  for (let j = 0; j < ques.checkedArr.length; j++) {
                    if (ques.checkedArr[j].id == tempQues.options[i].id) {
                      tempQues.options[i].sortNo = num++
                      break
                    } else {
                      tempQues.options[i].sortNo = 99
                    }
                  }
                }
              }
            } else if (ques.type === 'matrixRadio') {
              // 矩阵单选题
              ques.subTitles.forEach((title, i) => {
                tempQues.groups.push({
                  id: title.id,
                  options: []
                })
                ques.options.forEach(opt => {
                  tempQues.groups[i].options.push({
                    id: opt.id,
                    text: opt.text,
                    checked: opt.id === title.checked ? 1 : 0
                  })
                })
              })
            } else if (ques.type === 'matrixCheckbox') {
              // 矩阵多选题
              ques.subTitles.forEach((title, j) => {
                tempQues.groups.push({
                  id: title.id,
                  options: []
                })
                ques.options.forEach(opt => {
                  tempQues.groups[j].options.push({
                    id: opt.id,
                    text: opt.text,
                    checked: title.checked.indexOf(opt.id) > -1 ? 1 : 0
                  })
                })
              })
            } else if (ques.type === 'matrixStar') {
              // 矩阵打分题
              ques.subTitles.forEach(title => {
                tempQues.groups.push({
                  id: title.id,
                  text: ques.isFinish ? `${title.checkedStar}` : ''
                })
              })
            } else if (ques.type === 'chainedSelects') {
              // 联动题目
              let idList = [],
                textList = []
              let tempArr = ques.groups[ques.answerArr[0]]
              for (let i = 0; i < ques.answerArr.length; i++) {
                if (ques.answerArr[i] === undefined) break
                idList.push(tempArr.id)
                textList.push(tempArr.value)
                if (tempArr.children) {
                  tempArr = tempArr.children[ques.answerArr[i + 1]]
                }
              }
              tempQues.idList = idList
              tempQues.textList = textList
            } else if (ques.type === 'upload') {
              // 上传题
              tempQues.fileNameSrc = ques.fileNameSrc
              tempQues.fileNameDst = ques.fileNameDst
            } else if (ques.type === 'select') {
              // 下拉
              ques.options &&
                ques.options.forEach(opt => {
                  tempQues.options.push({
                    id: opt.id,
                    checked: Number(ques.checkedLabel === opt.text),
                    text: ques.checkedLabel === opt.text ? opt.text : ''
                  })
                })
            } else {
              ques.options &&
                ques.options.forEach(opt => {
                  tempQues.options.push({
                    id: opt.id,
                    checked: Number(opt.checked),
                    text: opt.checked ? opt.text : ''
                  })
                })
            }
            tempPage.questions.push(tempQues)
          })
          pages.push(tempPage)
        })
        this.handleAnswer(pages)
      })
    },
    // 问卷会定时提交当前答案,该功能目前可以忽略
    handleTempAnswer() {
      if (this.type == 'vr') {
        // VR问卷不提交临时答案
        return
      }
      const self = this
      let pages = [],
        tempPage,
        tempQues
      this.survey.pages.forEach(val => {
        tempPage = {
          id: val.id,
          questions: []
        }
        val.questions.forEach(ques => {
          if (this.controlArr[ques.index] === 0) return true
          tempQues = {
            id: ques.id,
            type: ques.type,
            text:
              ques.checkedStar !== undefined
                ? `${ques.checkedStar}`
                : ques.texts || '',
            options: ques.type.indexOf('matrix') === -1 ? [] : null,
            groups: ques.type.indexOf('matrix') > -1 ? [] : null,
            blanks: ques.type === 'region' ? [] : ques.blankSetting,
            assess: ques.assess || null
          }
          if (ques.type === 'region') {
            // 区域题
            tempQues.text = ques.blankSetting.join(',')
          } else if (ques.type === 'evaluate' || ques.type === 'nps') {
            // 评价题
            Object.assign(tempQues, ques.answer)
          } else if (ques.type === 'sort') {
            ques.options.forEach(opt => {
              tempQues.options.push({
                id: opt.id,
                sortNo: opt.sortNo ? opt.sortNo : '',
                text: opt.text
              })
            })
            let num = 1
            if (ques.checkedArr) {
              for (let i = 0; i < tempQues.options.length; i++) {
                for (let j = 0; j < ques.checkedArr.length; j++) {
                  if (ques.checkedArr[j].id === tempQues.options[i].id) {
                    tempQues.options[i].sortNo = num++
                    break
                  } else {
                    tempQues.options[i].sortNo = 99
                  }
                }
              }
            }
          } else if (ques.type === 'matrixRadio') {
            ques.subTitles.forEach((title, i) => {
              tempQues.groups.push({
                id: title.id,
                options: []
              })
              ques.options.forEach(opt => {
                tempQues.groups[i].options.push({
                  id: opt.id,
                  text: opt.text,
                  checked: opt.id === title.checked ? 1 : 0
                })
              })
            })
          } else if (ques.type === 'matrixCheckbox') {
            ques.subTitles.forEach((title, j) => {
              tempQues.groups.push({
                id: title.id,
                options: []
              })
              ques.options.forEach(opt => {
                tempQues.groups[j].options.push({
                  id: opt.id,
                  text: opt.text,
                  checked: title.checked.indexOf(opt.id) > -1 ? 1 : 0
                })
              })
            })
          } else if (ques.type === 'matrixStar') {
            ques.subTitles.forEach(title => {
              tempQues.groups.push({
                id: title.id,
                text: ques.isFinish ? `${title.checkedStar}` : ''
              })
            })
          } else if (ques.type === 'chainedSelects') {
            let idList = [],
              textList = []
            let tempArr = ques.groups[ques.answerArr[0]]
            for (let i = 0; i < ques.answerArr.length; i++) {
              if (ques.answerArr[i] === undefined) break
              idList.push(tempArr.id)
              textList.push(tempArr.value)
              if (tempArr.children) {
                tempArr = tempArr.children[ques.answerArr[i + 1]]
              }
            }
            tempQues.idList = idList
            tempQues.textList = textList
          } else if (ques.type === 'upload') {
            tempQues.fileNameSrc = ques.fileNameSrc
            tempQues.fileNameDst = ques.fileNameDst
          } else if (ques.type === 'select') {
            ques.options &&
              ques.options.forEach(opt => {
                tempQues.options.push({
                  id: opt.id,
                  checked: Number(ques.checkedLabel === opt.text),
                  text: ques.checkedLabel === opt.text ? opt.text : ''
                })
              })
          } else {
            ques.options &&
              ques.options.forEach(opt => {
                tempQues.options.push({
                  id: opt.id,
                  checked: Number(opt.checked),
                  text: opt.checked ? opt.text : ''
                })
              })
          }
          tempPage.questions.push(tempQues)
        })
        pages.push(tempPage)
      })
      http
        .post(self.interface.tempAnswer, {
          surveyId: self.SURVEY_ID,
          token: self.survey.token,
          userName: this.oa || null,
          surveyAnswer: JSON.stringify({
            id: self.SURVEY_ID,
            pages,
            startTime: self.startTime,
            endTime: new Date().getTime(),
            referrer: document.referrer, // 记录referrer
            invalidFlag: self.isInValid
          })
        })
        .then(response => {
          const { code } = response.data
          if (code !== 1) {
            window.clearInterval(timer)
            timer = null
          }
        })
        .catch(error => {
          window.clearInterval(timer)
          timer = null
          MSG.error(error)
        })
    },
    // 标签过滤
    removeLables(html) {
      if (!html) return ''
      return html.replace(/<\/?.+?>/g, '')
    },
    // 保存问卷
    handleAnswer(answer) {
      const self = this
      answer.forEach(val => {
        val.questions.forEach(ques => {
          if (ques.type === 'radio' || ques.type === 'checkbox') {
            ques.options.forEach(opt => {
              opt.text = self.removeLables(opt.text)
            })
          }
        })
      })
      const params = {
        surveyId: self.SURVEY_ID,
        token: self.survey.token, // 只有发放中的问卷才有token，确保唯一提交
        userName: this.oa || null,

        surveyAnswer: JSON.stringify({
          id: self.SURVEY_ID,
          pages: answer, // 填答内容
          startTime: self.startTime, // 问卷开始时间
          endTime: new Date().getTime(), // 填答结束时间，用于回收问卷
          referrer: document.referrer, // 记录referrer
          invalidFlag: self.isInValid // 是否有效
        })
      }
      // 业务扩展字段，在问卷链接后，用于业务数据上报 示例： ?ext=tianyaohui
      if (getParams('ext')) {
        params.ext = getParams('ext')
      }
      const loadingInstance = Loading.service({
        lock: true,
        text: '提交中',
        background: 'rgba(0, 0, 0, 0.3)'
      })
      http
        .post(self.interface.answer, params)
        .then(response => {
          const { code, data, message } = response.data
          if (code === 1) {
            window.clearInterval(self.countdownTimer) // 提交问卷完成后，清除定时器
            window.clearInterval(timer)
            self.countdownTimer = null
            timer = null
            window.scrollTo(0, 0)
            if (data !== undefined) {
              // 如果有打分，显示打分
              self.surveyScore = data
            }
            self.endUrl()
            /*  if (self.activePage < self.survey.pages.length) {
              self.activePage++;
              document.title = '提交成功';
            } */
          } else {
            MSG.error(message)
          }
          // 问卷被iframe嵌套使用，完成作答发送完成指令给iframe父页面
          self.showCountDownNotice = false // 隐藏倒计时提示
          window.parent.postMessage({ isSubmitted: Boolean(code) }, '*')
          loadingInstance.close()
        })
        .catch(error => {
          MSG.error(error) // 提交失败，给父页面发失败消息
          window.parent.postMessage({ isSubmitted: false }, '*')
          loadingInstance.close()
        })
    },
    // 单选题选中的处理逻辑
    handleCheckRadio(ques, index) {
      const self = this
      const temp = deepClone(ques, {})
      // 投票题
      if (ques.showStat) {
        let sum = 0
        ques.showVote = true // 计算投票数量
        for (const val of Object.values(ques.voteCountMap)) {
          sum += val
        }
        ques.countSum = sum + 1 // 投票数量
      }
      let _checkedOption = {}
      let _checkedIndex = 0
      temp.options.forEach((val, i) => {
        if (val.text === temp.checkedLabel) {
          // 如果为选中文本，则标记为选中true
          _checkedIndex = i
          val.checked = true
          _checkedOption = val
          if (val.id === '98') {
            // 98为其他选项
            self.handleShowDialog(ques)
          }
          this.recursionShowQues(val.visible)
        } else {
          val.checked = false // 没选中false
          // 清除已触发的多条件显示
          if (self.mulLinkMap[`${ques.index}-${i}`]) {
            self.mulLinkMap[`${ques.index}-${i}`].forEach(val => {
              if (self.notVisible.indexOf(val) === -1) {
                // 含有显示逻辑，修改notVisible数组
                self.notVisible.push(val)
              }
            })
            self.linkTo = ''
            self.linkCtrl(ques.index) // 跳转到目标题目
          }
          // 删除多条件显示
          if (val.mulKey !== '') {
            delete self.mulLinkMap[val.mulKey]
          }
          this.recursionHideQues(val.visible)
        }
        // notVisible数组中包含题目的下标，用于控制题目是跳转逻辑，哪些题目显示隐藏
        if (i === temp.options.length - 1) {
          const checkVal = _checkedOption
          if (!temp.referFlag) {
            if (checkVal.visible.length > 0) {
              checkVal.visible.forEach(idx => {
                if (self.notVisible.indexOf(idx) > -1) {
                  // 含有显示逻辑，修改notVisible数组
                  self.notVisible.splice(self.notVisible.indexOf(idx), 1)
                }
              })
            }
          }
          // 触发多条件显示
          if (self.mulLinkMap[`${ques.index}-${_checkedIndex}`]) {
            const _arr = self.mulLinkMap[`${ques.index}-${_checkedIndex}`]
            _arr.forEach(idx => {
              if (self.notVisible.indexOf(idx) > -1) {
                // 含有显示逻辑，修改notVisible数组
                self.notVisible.splice(self.notVisible.indexOf(idx), 1)
              }
            })
            self.linkTo = ''
            self.linkCtrl(ques.index) // 根据下标跳转到目标题目
          }
          // 添加多条件显示
          if (checkVal.mulKey !== '') {
            self.mulLinkMap[checkVal.mulKey] = checkVal.mulToQues
          }
          // 如果为选中选项，且不是引用
          if (checkVal.text === temp.checkedLabel && !temp.referFlag) {
            if (checkVal.goto) {
              // 有选项跳转记录跳转
              self.linkTo = +checkVal.goto
              if (self.linkTo === -3 && checkVal.gotoUrl) {
                this.linkUrl = checkVal.gotoUrl
              }
            } else if (temp.goto !== '-1') {
              // 有分页跳转，记录跳转
              self.linkTo = +temp.goto
            } else {
              // 否则无
              self.linkTo = ''
            }
            self.linkCtrl(index) // 根据下标跳转到目标题目
          }
        }
      })
      temp.isFinish = true // 该题作答完成
      Object.assign(ques, deepClone(temp, {}))
    },
    //解决链式显示逻辑问题
    recursionHideQues(visibles) {
      if (Array.isArray(visibles)) {
        // 含有显示逻辑，修改notVisible数组
        visibles.forEach(idx => {
          if (this.notVisible.indexOf(idx) === -1) {
            this.notVisible.push(idx)
            let element = this.queList[idx]
            if (Array.isArray(element.options)) {
              element.options.forEach(val => {
                this.recursionHideQues(val.visible)
              })
            }
          }
        })
      }
    },
    recursionShowQues(visibles) {
      if (Array.isArray(visibles)) {
        // 含有显示逻辑，修改notVisible数组
        visibles.forEach(idx => {
          let qIdx = this.notVisible.indexOf(idx)
          if (qIdx !== -1) {
            this.notVisible.splice(qIdx, 1)
            let element = this.queList[idx]
            if (Array.isArray(element.options)) {
              element.options.forEach(val => {
                if (val.checked) {
                  this.recursionShowQues(val.visible)
                }
              })
            }
          }
        })
      }
    },
    // 矩阵单选题的选中
    handleMatrixRadioCheck(ques) {
      const temp = deepClone(ques, {})
      temp.isFinish = true
      temp.subTitles.forEach(item => {
        if (!item.checked && (!ques.referFlag || item.display)) {
          temp.isFinish = false
        }
      })
      Object.assign(ques, deepClone(temp, {}))
    },
    // 矩阵打分题的选中
    handleMatrixStarChange(ques, idx) {
      const temp = deepClone(ques, {})
      temp.isFinish = true
      temp.subTitles[idx].activeFlag = true
      temp.subTitles.forEach(item => {
        if (typeof item.activeFlag === 'undefined') temp.isFinish = false
      })
      Object.assign(ques, deepClone(temp, {}))
    },
    // 矩阵多选题的选中
    handleMatrixCheckbox(ques) {
      const temp = deepClone(ques, {})
      temp.isFinish = true
      temp.subTitles.forEach(item => {
        if (!item.checked && (!ques.referFlag || item.display)) {
          temp.isFinish = false
        }
      })
      Object.assign(ques, deepClone(temp, {}))
    },
    handleInputText(ques) {
      const temp = deepClone(ques, {})
      temp.isFinish = temp.texts.trim() !== ''
      Object.assign(ques, deepClone(temp, {}))
    },
    handleInput(ques) {
      // const temp = deepClone(ques, {});
      // temp.texts = temp.texts.replace(/\uD83C[\uDF00-\uDFFF]|\uD83D[\uDC00-\uDE4F]/g, "");
      // Object.assign(ques, deepClone(temp, {}));
    },
    // 日期题目选中
    handleDateSelect(ques) {
      const temp = deepClone(ques, {})
      temp.isFinish = !!temp.texts
      Object.assign(ques, deepClone(temp, {}))
    },
    // 区域题目选中
    handleRegionSelect(ques) {
      const temp = deepClone(ques, {})
      temp.isFinish = temp.blankSetting.length > 0
      Object.assign(ques, deepClone(temp, {}))
    },
    // 文本题失去焦点校验
    handleBlurText(ques) {
      window.parent.postMessage({ isblur: true }, '*')
      const { texts = '' } = ques
      if (texts.length > ques.maxLength && ques.maxLength !== 0) {
        MSG.error(`输入的字数不得超过${ques.maxLength}`)
      }
      if (ques.title.match(/手机号/g)) {
        if (/^1[34578]\d{9}$/.test(texts)) {
          this.$data.phoneVaild = true
        }
        if (!ques.texts && !ques.required) {
          this.$data.phoneVaild = true
        }
      }
    },
    // focus 文本题目
    handleFocusText(ques, e) {
      this.textareValidateRules.texts[0].validator =
        validator[ques.validate] || validator.validateInit
    },
    // 打分题选中，处理跳转逻辑
    handleCheckStar(ques) {
      const temp = deepClone(ques, {})
      const checkedStar = temp.checkedStar
      const index = temp.index
      const starEntityList = temp.starEntityList
      if (starEntityList) {
        for (let i = 0; i < starEntityList.length; i++) {
          const entity = starEntityList[i]
          // 打分题跳转逻辑命中
          if (checkedStar >= entity.start && checkedStar <= entity.end) {
            if (entity.goto) {
              this.linkTo = +entity.goto // 记录跳转目标题目的下标
            } else {
              this.linkTo = '' // 否则为空
            }
            this.linkCtrl(index) // 处理跳转
            break
          }
          if (i === starEntityList.length - 1) {
            this.linkTo = ''
            this.linkCtrl(index) // 处理跳转
          }
        }
      }
      temp.isFinish = true
      Object.assign(ques, deepClone(temp, {}))
    },
    handleSelectChange(ques) {
      ques.isFinish = true
    },
    _handleQueFinish(ques) {
      const temp = deepClone(ques, {})
      temp.isFinish = true
      Object.assign(ques, deepClone(temp, {}))
    },
    handleSortEnd(ques) {
      this._handleQueFinish(ques)
    },
    handleCSFinish(ques) {
      const temp = deepClone(ques, {})
      Object.assign(ques, deepClone(temp, {}))
    },
    handleTextMulFinish(ques) {
      this._handleQueFinish(ques)
    },
    handleTextMulUnFinish(ques) {
      const temp = deepClone(ques, {})
      temp.isFinish = false
      Object.assign(ques, deepClone(temp, {}))
    },
    // 处理跳转逻辑，根据目标题目下标跳转到目标题目
    linkCtrl(idx) {
      let _since = idx === -1 ? 0 : idx + 1
      this.controlArr.fill(1, _since) // 跳转目标题目前的题目改为已作答 controlArr内标记相应题目为1
      if (this.linkTo === -1) {
        // 为-1记为无效
        this.isInValid = true
      } else {
        // 否则有效
        this.isInValid = false
      }
      if (this.linkTo < 0) {
        if (this.linkTo === -3) {
          this.linkToNewUrl = true
        } else {
          // 跳转到结束
          this.linkToEnd = true
        }
        this.controlArr.fill(0, idx + 1) // 0表示不作答
        this.toEndPerc = 100
        return
      }
      this.linkToNewUrl = false
      this.linkToEnd = false
      this.toEndPerc = 0

      if (this.linkTo > 0) {
        _since = this.linkTo
        this.controlArr.fill(0, idx + 1, this.linkTo) // 跳转到需要作答的目标题目，区间的题目不用做答记为0
        if (this.allQuestions[this.linkTo].pageIdx > this.activePage) {
          // 记录需要跳转的下一页
          this.nextPage = this.allQuestions[this.linkTo].pageIdx
        }
      } else {
        // 否则恢复跳转的下一页记录
        this.nextPage = this.tempNextPage
      }
      for (let i = _since; i < this.controlArr.length; i++) {
        // 从点击的下一题起，扫本页内第一个有逻辑的题
        if (!this.allQuestions[i]) {
          continue
        }
        const _ques = this.survey.pages[this.allQuestions[i].pageIdx].questions[
          this.allQuestions[i].quesIdx
        ]
        this.controlArr.splice(i, 1, 1) // controlArr数组中1表示需作答
        let isGoto = false
        if (_ques.type === 'radio') {
          isGoto = _ques.options.some(val => val.goto)
        }
        if (_ques.goto !== '-1' || isGoto) {
          if (_ques.type === 'radio') {
            _ques.checkedLabel = ''
          } // 若该题已作答，则清空作答
          if (_ques.type === 'checkbox') {
            _ques.options.forEach(val => {
              val.checked = false
            })
          }
          break
        }
      }
      this.notVisible.forEach(val => {
        // 不显示的题目
        this.controlArr.splice(val, 1, 0) // 不显示的题目不作答，controlArr数组中1表示作答，0表示不作答
      })
    },
    // 由于部分题目隐藏，不计算下标，计算正确题目的下标，
    getOrder(idx) {
      let order = 0
      for (let i = 0; i < idx; i++) {
        // controlArr数组中1表示作答，0表示不作答
        if (this.controlArr[i] === 1) order++
      }
      return order + 1
    },
    //
    preHandle() {
      const self = this
      function _randomOpt(arr) {
        // 选项随机处理
        const tempArr = [],
          norandomArr = []
        arr.forEach((val, idx) => {
          if (val.noRandom) {
            // 盘点选项是否随机，进行分离
            norandomArr.push({
              index: idx,
              opt: val
            })
          } else {
            tempArr.push(val)
          }
        })
        let otherTtem
        tempArr.sort(() =>
          // 随机的选项处理
          Math.random() > 0.5 ? -1 : 1
        )
        tempArr.map((e, i) => {
          // 其他选项始终在最后一个
          if (e.text.match(/^其他/g)) {
            otherTtem = e
            tempArr.splice(i, 1)
          }
          return ''
        })
        norandomArr.sort(
          (x, y) =>
            // 不随机的选项正常排序
            x.index > y.index
        )
        norandomArr.forEach(val => {
          // 合并随机选项、不随机选项
          tempArr.splice(val.index, 0, val.opt)
        })
        if (otherTtem) tempArr.push(otherTtem) // 和并其他选项
        return tempArr
      }
      this.survey.pages.forEach(page => {
        page.questions.forEach(ques => {
          const type = ques.type
          if (
            ques.random &&
            ['radio', 'checkbox', 'select'].indexOf(type) > -1
          ) {
            ques.options = _randomOpt(ques.options)
          }
          if (type === 'radio' || type === 'checkbox') {
            // 单选、多选跳转逻辑的显示隐藏处理，根据选项的visible做判断处理
            ques.options.forEach(val => {
              if (val.visible && val.visible.length > 0) {
                val.visible.forEach(idx => {
                  if (self.notVisible.indexOf(idx) === -1) {
                    self.notVisible.push(idx)
                  }
                })
              }
              if (val.mulToQues && val.mulToQues.length > 0) {
                val.mulToQues.forEach(idx => {
                  // 多条件跳转逻辑中目标显示题预先添加到notVisible数组中隐藏
                  if (self.notVisible.indexOf(idx) === -1) {
                    self.notVisible.push(idx)
                  }
                })
              }
            })
          }
          if (type === 'textMultiple') {
            // 填空题的处理方式，
            const _textArr = ques.title.split(/_+/g)
            const _underArr = ques.title.split(/[^_]+/g)
            const _max =
              _textArr.length > _underArr.length
                ? _textArr.length
                : _underArr.length
            const firstFlag = _textArr[0] === '' ? 'under' : 'text'
            for (let i = 0; i < _max; i++) {
              if (_textArr[i] === '') _textArr.splice(i, 1)
              if (_underArr[i] === '') {
                _underArr.splice(i, 1)
              } else {
                ques.blankSetting.push({
                  id: uuid(),
                  validate: null,
                  type: 'question',
                  attach_id: ques.id,
                  value: ''
                })
              }
            }
            ques.textArr = _textArr
            ques.underArr = _underArr
            ques.firstFlag = firstFlag
          }
        })
      })
    },
    scrollTop() {
      window.scrollTo(0, 0)
    },
    doBlur() {
      // 解决ios光标问题
      document.activeElement.blur()
    },
    handleShowDialog(ques) {
      if (this.type === 'vr') {
        // VR问卷不弹框
        return
      }
      ques.options.forEach(val => {
        if (val.id === '98') {
          this.$nextTick(() => {
            this.tempQues = ques
            this.tempBlankValue = ques.blankSetting[0].value
            this.dialogVisible = true
          })
        }
      })
    },
    // 确认关闭其他弹框
    handleDialogConfirm(val) {
      this.tempQues.blankSetting[0].value = val
      this.dialogVisible = false
    },
    handleCreate() {
      let url = 'https://wenjuan.58.com/'
      const obj = this.survey.surveyAdvanceSettingObj
      if (
        this.survey.advanceSettingFlag &&
        !obj.hideEndPageButton &&
        obj.suffixButtonSetting &&
        obj.suffixButtonSetting.url
      ) {
        url = obj.suffixButtonSetting.url
      }
      window.location.href = url
    },
    pageResizeObserver() {
      const callback = (mutations) => {
        mutations.forEach((mutation) => {
          if (targetNode && (targetNode.offsetWidth !== this.targetSize.width || targetNode.offsetHeight !== this.targetSize.height)) {
            this.targetSize.width = targetNode.offsetWidth
            this.targetSize.height = targetNode.offsetHeight
            window.parent.postMessage({ pageWidth: this.targetSize.width, pageHeight: this.targetSize.height }, '*')
          }
        })
      }
      const targetNode = document.getElementById('app')
      const config = { attributes: true, childList: true, subtree: true }
      this.observer = new MutationObserver(callback)
      this.observer.observe(targetNode, config)
    }
  }
}
</script>

<style lang="scss">
p strong {
  font-weight: bold;
}
.showIsSubmit.el-message {
  min-width: 250px;
  top: 0;
}
.survey-page {
  width: 100%;
  .el-radio-group,
  .checkbox-group {
    display: flex;
    flex-wrap: wrap;
  }
  .ques-item-checkbox .checkbox-group,
  .ques-item-checkbox .checkbox-group > div {
    width: 100%;
  }
  .ques-item-checkbox .checkbox-group > div {
    display: flex;
    flex-wrap: wrap;
  }
  .no-checkbox {
    .el-radio__input,
    .el-checkbox__input {
      display: none;
    }
  }
  .ques-title-inner {
    display: flex;
  }
  .ques-title-description {
    flex-direction: column;
  }
  .head-img {
    margin-top: -80px;
    // margin-bottom: 83px;
    overflow: hidden;
    position: relative;
    img {
      width: 100%;
      max-height: 180px;
    }
  }
  .progressBar {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 99999;
    .el-progress-bar__outer {
      background-color: transparent;
    }
  }
  .survey-countdown-notice {
    background-color: #ff9981; //rgba(255, 85, 46, 0.6)
    height: 30px;
    line-height: 30px;
    color: #fff;
    text-align: center;
    font-size: 12px;
    z-index: 100000;
    position: absolute;
    left: 0;
    width: 100%;
  }
  .survey-countDown-page {
    height: 100%;
  }
  .survey-status {
    opacity: 0.6;
    height: 30px;
    color: #fff;
    font-size: 12px;
    z-index: 100000;
    position: fixed;
    display: flex;
    align-items: center;
    justify-content: center;
    left: 0;
    width: 100%;
    .status-icon {
      opacity: 0.6;
      text-align: center;
      width: 15px;
      height: 15px;
      margin-right: 3px;
      line-height: 15px;
      display: inline-block;
      border-radius: 50%;
      background-color: #fff;
      font-weight: bold;
    }
  }
  .preview-topbar {
    padding: 0 1rem;
    width: 100%;
    background-color: #ff9981;
    height: 2.2rem;
    line-height: 2.2rem;
    font-size: 0.7rem;
    color: #fff;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 100;
    a {
      width: 4rem;
      height: 1.4rem;
      line-height: 1.4rem;
      text-align: center;
      float: right;
      margin-top: 0.4rem;
      background-color: #f9f9f9;
      border-radius: 15px;
      font-size: 0.6rem;
    }
  }
  .survey-content {
    width: 100%;
    padding: 50px 0;
    &.survey-preview {
      padding: 0;
    }
    &.active {
      height: 100%;
      padding-bottom: 100px;
      text-align: center;
    }
  }
  .survey-wrap {
    width: 100%;
    max-width: 1000px;
    // min-width: 730px;
    border: 1px solid #dadada;
    position: relative;
    background-color: #fff;
    font-size: 14px;
    line-height: 22px;
    margin: auto;
    &.survey-preview {
      height: 100%;
    }
    &.active {
      height: 100%;
    }
  }
  .survey-main {
    padding-top: 80px;
    padding-bottom: 100px;
    max-width: 600px;
    margin: 0 auto;
    a {
      color: #479de6;
      text-decoration: underline;
    }
    .survey-title {
      padding-bottom: 15px;
      text-align: center;
      -ms-word-break: break-all;
      font-size: 24px;
      font-weight: bold;
      word-break: break-all;
      .survey-inner {
        line-height: 33px;
        font-weight: 600;
        color: $font-color-deep;
      }
      p {
        line-height: 33px;
        font-weight: 600;
        color: $font-color-deep;
      }
    }
    .survey-inner {
      padding: 20px 0;
    }
    .textMultiple {
      text-align: left;
      border-radius: 0;
      appearance: none;
      -webkit-appearance: none;
      border: 0;
      border-bottom: 1px solid #000;
      background-color: transparent;
    }
    .survey-prefix {
      color: #555;
      margin-bottom: 35px;
      .survey-inner {
        padding: 0;
        line-height: 24px;
      }
    }
    .survey-pages {
      display: none;
      &.active {
        display: block;
      }
      .nextBtn {
        text-align: center;
      }
      .endPage {
        text-align: center;
        margin-top: 8%;
        position: relative;
        img {
          text-align: center;
          width: 252px;
        }
        .create-btn {
          display: block;
          margin: 30px auto 0;
          text-align: center;
          width: 200px;
          height: 40px;
          border-radius: 20px;
          filter: blur(0px);
          cursor: pointer;
        }
      }
      .el-radio__label,
      .el-checkbox__label {
        position: relative;
      }
      .index {
        width: 30px;
        height: 43px;
        line-height: 43px;
        color: #333;
        background-color: #ddd;
        text-align: center;
      }
      .answer-container {
        position: absolute;
        left: 35px;
        top: 0;
        height: 100%;
        width: 250px;
        border: 1px solid #ddd;
        box-sizing: border-box;
      }
      .option-container {
        position: absolute;
        margin-left: 40px;
        top: 0;
        width: 100%;
      }
      .option-item {
        display: block;
        width: 100%;
        margin-right: 25px;
        margin-bottom: 3px;
        background-color: #ddd;
        .el-input__inner {
          width: 100% !important;
          padding: 10px !important;
        }
      }
      .option-container {
        width: 95%;
      }
    }
  }
  .survey-cover {
    position: relative;
    height: 667px;
    background-size: 100%;
    /*width: 100vw;*/
    overflow: hidden;
    background-repeat: no-repeat;
    background-attachment: fixed;
    .survey-cover-info {
      padding: 30px 15px;
      position: absolute;
      left: 20px;
      right: 20px;
      bottom: 20px;
      overflow: hidden;
      background: inherit;
      .blur-box {
        width: 120%;
        height: 120%;
        margin-left: -10%;
        margin-top: -10%;
        filter: blur(15px);
        background: inherit;
        position: absolute;
        top: 0;
        z-index: 9;
      }
    }
    .survey-cover-title {
      font-size: 30px;
      color: #fff;
      font-weight: bold;
      line-height: 45px;
      margin-bottom: 20px;
      position: relative;
      z-index: 10;
    }
    .survey-cover-desc {
      font-size: 12px;
      color: #f5f5f5;
      text-align: justify;
      line-height: 21px;
      margin-bottom: 30px;
      position: relative;
      z-index: 10;
    }
    .survey-cover-arrow {
      width: 28px;
      height: 28px;
      position: absolute;
      left: 50%;
      margin-left: -14px;
      bottom: 15px;
      background: url(../assets/arrow@2x.png) no-repeat center center;
      background-size: contain;
      animation: mymove 1.5s infinite;
      z-index: 10;
    }
    @keyframes mymove {
      0% {
        bottom: 15px;
      }
      50% {
        bottom: 5px;
      }
      100% {
        bottom: 15px;
      }
    }
  }
  .textAreaTooltip .el-form-item__error {
    color: #fff;
    font-size: 14px;
    display: inline-block;
    padding: 0 8px;
    border-radius: 15px;
    height: 22px;
    line-height: 22px;
    position: absolute;
    top: -17px;
  }
  .matrixRadio-subtitle {
    position: absolute;
    width: 160px;
    text-align: left;
    word-break: break-all;
    .subtitle-text {
      height: 60px;
      line-height: 20px;
    }
  }
  .limitedTips {
    padding: 30px;
    font-size: 16px;
    color: #333;
    text-align: center;
  }
  .unFinishedTips {
    color: #fff;
    font-size: 14px;
    display: inline-block;
    padding: 0 8px;
    border-radius: 15px;
  }
  .question-viewer {
    margin-bottom: 25px;
    position: relative;
    a {
      color: #479de6;
      text-decoration: underline;
    }
    .el-radio {
      vertical-align: top;
      img {
        max-width: 100%;
      }
      .el-radio__label {
        width: calc(100% - 18px);
        display: inline-block;
        white-space: pre-line;
        word-wrap: break-word;
        vertical-align: text-top;
      }
      &.starRadio {
        .el-radio__label {
          width: auto;
          vertical-align: middle;
        }
      }
    }
    .el-checkbox {
      img {
        max-width: 100%;
      }
      .el-checkbox__input {
        vertical-align: top;
        // .el-checkbox__inner {
        //   top: 6px;
        // }
      }
      .el-checkbox__label {
        width: calc(100% - 18px);
        white-space: pre-line;
        word-wrap: break-word;
        vertical-align: text-top;
      }
    }
    .starText {
      font-size: 14px;
      position: absolute;
      top: -22px;
      margin: 0;
      line-height: 24px;
      left: 0;
      color: #666;
      &.end {
        left: auto;
        right: 0;
      }
    }
    .el-radio-group:not(.starRadios) {
      width: 100%;
    }
    .starRadios {
      position: relative;
    }
    .el-radio + .el-radio {
      margin-left: 0;
    }
    .starRadio {
      line-height: 24px;
    }
    .el-radio.is-checked {
      .el-radio__label {
        font-size: 14px;
        font-weight: bold;
      }
    }
    .el-checkbox,
    .el-radio:not(.starRadio) {
      margin-bottom: 20px;
      margin-right: 0;
      &.row-1 {
        width: 100%;
        .radioContentVote {
          width: calc(100% - 100px);
        }
      }
      &.row-2 {
        width: 50%;
      }
      &.row-3 {
        width: 33.3%;
      }
      &.row-4 {
        width: 25%;
      }
      &.row-5 {
        width: 20%;
      }
      &.row-6 {
        width: 16.6%;
      }
      &.row-7 {
        width: 14.2%;
      }
      &.row-8 {
        width: 12.5%;
      }
      &.row-9 {
        width: 11.1%;
        .el-radio__label {
          padding-left: 5px;
        }
      }
      &.row-10 {
        width: 10%;
        .el-radio__label {
          padding-left: 5px;
        }
      }
    }
    .el-checkbox + .el-checkbox,
    .el-radio:not(.starRadio) + .el-radio:not(.starRadio) {
      margin-left: 0;
    }
    .ques-title {
      line-height: 22px;
      display: flex;
      font-size: 16px;
      color:$font-color-deep;
      font-weight: 600;
      width: 100%;
      .ques-title-inner {
        margin-left: 30px;
        margin-right: 15px;
        display: inline-block;
        font-size: 16px;
        color:$font-color-deep;
        font-weight: 600;
        p {
          font-size: 16px;
          color:$font-color-deep;
          font-weight: 600;
        }
        img {
          max-width: 100%;
        }
      }
      .ques-title-idx {
        font-size: 16px;
        color:$font-color-deep;
        font-weight: 600;
        white-space: nowrap;
        margin-right: -25px;
        vertical-align: top;
      }
      img {
        max-width: 100%;
      }
    }
    .required-icon {
      font-size: 20px;
      display: inline-block;
      height: 22px;
      line-height: 30px;
      vertical-align: middle;
      margin-left: -10px;
      margin-right: 10px;
      align-self: center;
      font-weight: normal;
    }
    .ques-desc {
      margin-top: 5px;
      margin-bottom: 20px;
      color: #999;
    }
    .otherStr {
      width: 70px;
      margin-left: 35px;
      position: absolute;
      border: none;
      height: 18px;
      background-color: transparent;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
      &.checkboxOther {
        margin-left: 0;
        left: 40px;
        top: auto;
        background-color: transparent;
      }
    }
    .matrix-disp.matrixRadio-disp {
      margin-left: 160px;
      .matrix-title {
        padding-left: 0px;
      }
    }
    .matrix-disp {
      text-align: center;
      overflow-x: auto;
      overflow-y: hidden;
      .matrix-title {
        display: flex;
        word-break: break-all;
        padding-left: 100px;
      }
      .matrix-option {
        flex: 1;
        min-width: 80px;
      }
      .matrix-content {
        height: 40px;
        line-height: 40px;
      }
      .matrix-subtitle {
        width: 100px;
        text-align: left;
        word-break: break-all;
        float: left;
      }
    }
    .inputs {
      position: relative;
      .matrix-group {
        position: relative;
        margin-left: 100px;
      }
      .table-scoll {
        overflow-x: auto;
        overflow-y: scroll;
        -webkit-overflow-scrolling: touch;
        zoom: 1;
      }
      .option_title {
        font-weight: normal;
        overflow: hidden;
        text-overflow: ellipsis;
        text-align: center;
        min-width: 68px;
      }
      .option_choose {
        min-width: 68px;
        text-align: center;
        vertical-align: middle;
        // padding-top: 14px;
        // line-height: 20px;
      }
      .table_freezed {
        border-spacing: 0;
        margin-left: -100px;
        width: 100%;
        .el-radio__label,
        .el-checkbox__label {
          display: none;
        }
        .inputs .el-radio {
          margin-bottom: 0 !important;
        }
      }
      .sub_title {
        min-width: 100px;
        width: 100px;
        padding-top: 14px;
        padding-bottom: 20px;
        .subtitle_text {
          line-height: 20px;
          overflow: hidden;
          position: relative;
        }
      }
      .matrix_group_mirror {
        position: absolute;
        border-spacing: 0;
        top: 0px;
        width: 100px;
        min-width: auto;
        z-index: 99;
        background-color: #fff;
      }
    }

    .matrix-body {
      position: relative;
    }
    .matrix-star-text {
      width: 100%;
      overflow: hidden;
      padding-left: 100px;
      height: 26px;
      .matrix-starText {
        position: absolute;
        font-size: 12px;
        left: 100px;
        &:last-child {
          right: 20px;
          left: auto;
        }
      }
    }
    .matrix-star-sub {
      min-height: 40px;
      overflow: hidden;
    }
    .star-sub-title {
      text-align: left;
      width: 100px;
      padding-right: 10px;
      min-height: 40px;
      line-height: 20px;
      padding-bottom: 10px;
      padding-top: 10px;
      word-break: break-all;
    }
    .slider-star {
      float: left;
      width: calc(100% - 110px);
    }

    .el-slider__button {
      border: solid 2px #eee;
    }
    .el-slider__bar {
      background-color: transparent;
    }
    .voteCountDisp {
      float: left;
      margin-right: 5px;
    }
    .votePercDisp {
      float: left;
    }
    .radioContent {
      float: left;
    }
  }
  @media screen and (max-width: 500px) {
    .head-img {
      margin-left: -25px;
      margin-right: -25px;
      margin-top: -15px;
    }
    .survey-wrap {
      min-width: 320px;
    }
    .survey-content {
      padding: 0;
      &.active {
        padding-bottom: 0;
        height: 100vh;
      }
      .pc-logo {
        display: none;
      }
    }
    .survey-main {
      padding: 30px 25px 80px;
      .survey-inner {
        padding-top: 10px;
        padding-bottom: 15px;
      }
    }
    .survey-prefix {
      margin-bottom: 30px;
      .survey-inner {
        line-height: 21px;
        color: $font-color-deep;
      }
    }
    .question-viewer {
      .el-radio + .el-radio {
        margin-left: 0;
      }
      .starRadio {
        width: 20%;
        margin-right: 0;
      }
    }
    .survey-cover {
      display: block;
    }
  }
  .drgContain {
    position: relative;
  }
  .drg {
    height: 26px;
    width: 20px;
    position: absolute;
    right: 9%;
    top: 7px;
    opacity: 0.6;
    z-index: 999;
    cursor: move;
  }
  @media screen and (min-width: 600px) {
    .starRadios {
      display: flex;
    }
    .starRadio {
      flex: 1;
    }
    .survey-cover {
      display: none;
    }
  }
  .el-dialog__footer {
    text-align: center;
  }
  .noQNum {
    .ques-title-inner {
      margin-left: 0 !important;
    }
    .ques-title-idx {
      display: none;
    }
  }
}
.el-form-item.is-success .el-input__inner,
.el-form-item.is-success .el-textarea__inner {
  border-color: #dcdfe6 !important;
}
.bottom-text {
  width: 100%;
  display: none;
  text-align: center;
  height: 33px;
  font-size: 0.65rem;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(222, 222, 222, 1);
  line-height: 37px;
  letter-spacing: 5px;
  bottom: 3rem;
  position: absolute;
}
.pc-logo {
  display: none;
  text-align: center;
  &.active {
    display: inline-block;
    width: 100px;
    margin-top: 20px;
  }
}
@supports (bottom: env(safe-area-inset-bottom)) {
  .bottom-text {
    padding-bottom: env(safe-area-inset-bottom);
  }
}
.clock-icon {
  text-align: center;
  background-image: url(../assets/clock.svg);
  background-repeat: no-repeat;
  background-size: contain;
  width: 200px;
  height: 200px;
  display: inline-block;
  margin: 0 5px;
}
.survey-countDown-page {
  .survey-wrap {
    height: 100%;
    padding-top: 50px;
  }
  p {
    font-size: 18px;
    padding-left: 20px;
    padding-right: 20px;
    color: #333;
  }
  .first-line {
    padding-top: 20px;
    padding-bottom: 10px;
  }
}
.nextBtn .mobile-btn {
  width: 200px;
  border-radius: 2px;
  margin-top: 15px;
  padding: 10px 20px;
  span {
    font-weight: bold;
  }
}
.is-radius .mobile-btn {
  border-radius: 1.25rem;
}
.survey-1053105-score {
  font-size: 16px;
  span {
    font-size: 28px;
    color:red;
    font-weight: bold;
  }
}
@media screen and (min-width: 500px) and (max-width: 630px) {
  .survey-page {
    .survey-content {
      padding: 0;
    }
    .head-img {
      margin-top: -20px;
    }
    .survey-main {
      padding-top: 20px;
    }
    .survey-wrap {
      padding: 0 20px;
    }
    .starRadios {
      display: flex;
    }
    .starRadio {
      flex: 1;
    }
    .survey-cover {
      display: none;
    }
    .create-btn {
      display: none;
    }
  }
}
@media screen and (max-width: 500px) {
  /* 手机端CSS代码 */
  .survey-page .survey-wrap {
    font-size: 0.7rem;
    border: none;
    .el-radio:focus:not(.is-focus):not(:active):not(.is-disabled)
      .el-radio__inner {
      -webkit-box-shadow: initial;
      box-shadow: initial;
    }
    .el-form .el-checkbox__inner {
      display: inline-block;
      width: 1rem;
      height: 1rem;
      top: 3px;
      &:after {
        height: 0.5rem;
        left: 0.35rem;
        width: 0.2rem;
        top: 0.15rem;
        border-width: 1px;
      }
    }
    .el-checkbox__label {
      vertical-align: middle;
    }
    .el-radio__inner {
      display: inline-block;
      border-radius: 50%;
      width: 1rem;
      height: 1rem;
      &:after {
        border-radius: 0;
        -webkit-box-sizing: content-box;
        background-color: transparent;
        box-sizing: content-box;
        content: '';
        border: 1px solid #fff;
        border-left: 0;
        border-top: 0;
        height: 0.5rem;
        left: 0.35rem;
        width: 0.2rem;
        top: 0.15rem;
        position: absolute;
        transform: rotate(45deg) scaleY(1);
      }
    }
    .el-radio__input.is-checked .el-radio__inner::after {
      transform: rotate(45deg) scaleY(1);
    }
    .mobile-radio {
      display: flex;
      flex-wrap: wrap;
      align-content: space-around;
      justify-content: space-between;
      .el-radio__input {
        padding-top: 0.75rem;
      }
    }
    .mobile-radio .el-radio__inner {
      display: inline-block;
      border-radius: 50%;
      width: 2rem;
      height: 2rem;
      &:after {
        border-radius: 0;
        -webkit-box-sizing: content-box;
        background-color: transparent;
        box-sizing: content-box;
        content: '';
        border: 0;
        border-left: 0;
        border-top: 0;
        height: 0;
        left: 0;
        width: 0;
        top: 0;
        position: absolute;
        transform: rotate(45deg) scaleY(1);
      }
    }
  }
  .survey-page .question-viewer {
    .ques-title {
      display: flex;
      align-items: center;
      background-color: #f9f9f9;
      position: relative;
      left: -25px;
      width: calc(100% + 50px);
      padding-left: 25px;
      font-size: 0.75rem;
      .ques-title-inner {
        line-height: 1.25rem;
        margin-top: 0.75rem;
        margin-bottom: 0.75rem;
      }
      .ques-title-idx {
        height: 1.25rem;
        line-height: 1.25rem;
        margin-top: 0.75rem;
        align-self: flex-start;
        word-break: keep-all;
      }
      &.ques-title-description {
        padding-right: 25px;
        display: block;
      }
    }
    .ques-desc {
      font-size: 0.65rem;
    }
    .nps-ques {
      .score-bar {
        .score-desc {
          font-size: 0.65rem
        }
        .score-block {
          height: 2.15rem;
          line-height: 2.15rem;
          margin-right: 0.175rem;
          border-radius: 0.15rem;
        }
      }
      .lable-wrap {
        margin-top: 10px;
      }
    }
    .el-checkbox:last-of-type,
    .el-radio:last-of-type {
      margin-bottom: 0px;
    }
    .el-radio {
      /*height: 1rem;*/
      line-height: 1rem;
      .el-radio__label {
        vertical-align: top;
      }
    }
    .el-checkbox .el-checkbox__input .el-checkbox__inner {
      top: -1px;
    }
    .el-checkbox .el-checkbox__label {
      vertical-align: sub;
    }
    .mobile-radio {
      .el-radio {
        height: 2.75rem;
      }
      .el-radio.starRadio .el-radio__label {
        font-weight: bold;
        position: relative;
        text-align: center;
        color: #666;
        display: flex;
        height: 2rem;
        line-height: 2rem;
        padding-left: 0;
        bottom: calc(2rem + 2px);
        justify-content: center;
      }
      .el-radio.starRadio .el-radio__input {
        width: 100%;
      }
      .el-radio.is-checked .el-radio__label {
        color: #fff;
      }
    }
    .inputs {
      // .matrix_group_mirror,
      // .sub_title {
      //   width: 33%;
      //   min-width: 33%;
      // }
      .el-checkbox:last-of-type,
      .el-radio:last-of-type {
        margin-bottom: 20px;
      }
      .matrix-group {
        margin-left: 33%;
      }
      .table_freezed {
        margin-left: -100px;
      }
    }
    .inputs .table_freezed .el-radio:last-of-type {
      margin-bottom: 0 !important;
    }
    .el-slider__bar {
      height: 6px;
      border-top-left-radius: 3px;
      border-bottom-left-radius: 3px;
      position: absolute;
    }
    .el-slider__stop {
      background-color: transparent;
    }
    .el-slider__runway {
      background-color: #eee;
    }
    .chainedSelects .el-input,
    .option-item .el-input__inner,
    .el-select .el-input .el-input__inner {
      caret-color: rgba(0, 0, 0, 0);
    }
    .starRadio {
      width: 20%;
      text-align: center;
      margin-right: 0;
    }
    .el-select,
    .el-input.el-input--suffix {
      width: 100%;
    }
  }
  .el-form-item .el-textarea__inner {
    -webkit-appearance: none;
  }
  .el-form-item.is-success .el-textarea__inner {
    border-color: #dcdfe6;
    -webkit-appearance: none;
  }
  .survey-page .survey-main .survey-pages {
    .textMultiple {
      color: #666;
    }
    .index {
      width: 42px;
      height: 40px;
      margin-bottom: 3px;
      line-height: 43px;
      color: #333;
      background-color: #f0f0f0;
      text-align: center;
      border-bottom-left-radius: 10px;
      border-top-left-radius: 10px;
      border: 1px solid #dcdfe6;
    }
    .option-item {
      display: block;
      width: auto;
      margin-right: 8%;
      margin-bottom: 3px;
      background-color: #fff;
      .el-input__inner {
        padding: 10px !important;
        border-bottom-right-radius: 10px;
        border-top-right-radius: 10px;
        border-bottom-left-radius: 0;
        border-top-left-radius: 0;
      }
    }
    .nextBtn .mobile-btn {
      width: 100%;
      height: 2.5rem;
      max-height: 40px;
    }
  }
  .survey-page .survey-countDown-page p {
    font-size: 0.8rem;
  }
  .survey-page .survey-main .survey-pages {
    .endPage {
      text-align: center;
      min-height: 13rem;
      img {
        text-align: center;
        width: 10.5rem;
      }
      .create-btn {
        text-align: center;
        width: 10rem;
        height: 2.2rem;
        border-radius: 50px;
        filter: blur(0px);
        position: absolute;
        left: calc(50% - 5rem);
        bottom: -46px;
        margin-top: 0;
        cursor: pointer;
      }
    }
  }
  .bottom-text {
    display: none;
    height: 33px;
    font-size: 0.65rem;
    line-height: 37px;
    letter-spacing: 5px;
    bottom: 3rem;
    &.active {
      display: block;
    }
  }
}
.survey-page {
  .agreement {
    margin-top: 20px;
    display: flex;
    align-items: center;
    .el-checkbox.is-bordered {
      border: none;
      padding: 3px 2px 3px 10px;
      .el-checkbox__inner {
        border-radius: 50% !important;
        top: 1px;
        ::after {
          left: 4px;
          top: 1px;
        }
      }
      .el-checkbox__input.is-checked + .el-checkbox__label {
        color: #606266;
      }
    }
    a.legal-name {
      text-decoration: none;
    }
  }
  > .cube-popup {
    .header {
      height: 40px;
      line-height: 40px;
      text-align: center;
      font-size: 16px;
      color: #606266;
      position: relative;
      i {
        position: absolute;
        right: 15px;
        top: 11px;
        cursor: pointer;
      }
    }
    .cube-popup-content {
      height: 40%;
      background-color: #fff;
      border-radius: 15px 15px 0 0;
    }
    .legal-content {
      position: absolute;
      left: 0;
      top: 40px;
      height: 100%;
      overflow-y: auto;
      padding: 5px 15px;
    }
  }
  .is-bottom .submit {
    position: fixed;
    bottom: 10px;
    left: 50%;
    transform: translateX(-50%);
    z-index: 2;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/survey.vue